/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
/* eslint-disable no-console */
import React from "react";
import "../../assets/styles/App.css";
import Sidebar from "./Sidebar";
import AppNavbar from "./AppNavbar";
import FsLightbox from "fslightbox-react";
import $ from "jquery";
import CustomGenerateReportModal from "./CustomGenerateReportModal";
import CustomGenerateReportWithoutImagesModal from "./CustomGenerateReportWithoutImagesModal";
import CustomEditExamDetailsModal from "./CustomEditExamDetailsModal";
import CustomEditPatientExamModal from "./CustomEditPatientExamModal";
import CustomKeratometryModal from "./CustomKeratometryModal";
import CustomABHAModal from "./CustomABHAModal";
import CustomFieldsDataModal from "./CustomFieldsDataModal";
import CustomReportFormatModal from "./CustomReportFormatModal";
import MyopiaPredictiveGraphModal from "./MyopiaPredictiveGraphModal";
import MyopiaRefractionChoiceModal from "./MyopiaRefractionChoiceModal";
import BiometryPDF from "./BiometryPDF";
import MyopiaPDF from "./MyopiaPDF";
import { pdf } from "@react-pdf/renderer";
import { toast } from "react-toastify";
import { gradeExam } from "../../constants/endpoints";
import { postAuthenticatedFormData } from "../../utils/async";
import {
  getImages,
  getVideos,
  getUser,
  getReportLink,
  getReportLinkByReportId,
  getExamDetails,
  getAIReportLink,
  getEyrisReportLink,
  assignExam,
  zipExam,
  getPathForDownload,
  getSites,
  getSiteLogo,
  getMyopiaReportLink,
  addMyopiaReportToExam,
  getPatientWithExams,
  addSubjectiveRefraction
} from "../../constants/endpoints";
import {
  getAuthenticatedData,
  putAuthenticatedData,
  postAuthenticatedData
} from "../../utils/async";
import {
  generateGrowthCurveGraph,
  generatePredictiveCurveGraph
} from "../../utils/myopiaGraphGenerator";
import { Button, FormGroup } from "react-bootstrap";
import { convertEpochToDate, convertEpochToTime } from "../../utils/date";
import LightGallery from "../../lib/lightgallery/react";
import lgThumbnail from "../../lib/lightgallery/plugins/thumbnail";
import "../../lib/lightgallery/css/lightgallery.css";
import "../../lib/lightgallery/css/lg-thumbnail.css";
import { withTranslation } from "react-i18next";
import i18next from "i18next";
import {
  T_ENTITIES,
  T_EXAMS,
  T_REPORT,
  T_NEUBO
} from "../../constants/translations";
import {
  isNeuboDevice,
  splitRiskFactors,
  formatBirthWeight,
  formatBirthTypeOrder,
  formatWeeksDays,
  postMenstrualAge,
  formatPersonName
} from "../../constants/neubo";
import ReactTooltip from "react-tooltip";

// import { Link } from "react-router-dom";
/**
 * This is the component for the Exam Details pages.<br>
 * It uses fs-lightbox-react for the gallery view. <br>
 *
 * SRS IDs: <br>
 * AIM - 5.3.14.5, 5.3.14.6, 5.3.14.20, 5.3.14.23, 5.3.14.25, 5.3.14.26, 5.3.14.29 <br>
 * PSL - 5.3.14.5, 5.3.14.6, 5.3.14.20, 5.3.14.23, 5.3.14.25, 5.3.14.26, 5.3.14.29 <br>
 * FOP - 5.3.14.5, 5.3.14.6, 5.3.14.20, 5.3.14.24, 5.3.14.26, 5.3.14.27 <br>
 *
 * @component
 */
class ExamDetails extends React.Component {
  constructor(props) {
    super(props);

    this.t = props.t;
    this.i18n = props.i18n;

    this.state = {
      isLoaded: false,
      userResults: getAuthenticatedData(
        sessionStorage.getItem("domain") + getUser
      ),
      images: [],
      imagesBig: [],
      imageCaptions: [],
      videos: [],
      videoThumbnails: [],
      slideVideos: 999,
      togglerVideos: false,
      small: [],
      smallEdited: [],
      toggler: false,
      examId: this.props?.location?.state?.exam?.examDetails?.id || null,
      showGenerateReportModal: false,
      showGenerateReportWithoutImagesModal: false,
      showEditExamDetailsModal: false,
      ocularHistory: "",
      systemicHistory: "",
      showEditPatientModal: false,
      currentMedication: "",
      allergies: "",
      isDoctor: false,
      slide: 999,
      report: {},
      patientDetails: null,
      editableAttributes: {},
      selectedAttribute: "ocularHistory",
      selectedTab: 3,
      examDetails: {},
      OneSecondOver: false,
      visionAssessment:
        this.props?.location?.state?.exam?.visionAssessment || null,
      toggledSegments: {},
      toggledSegmentsEdited: {},
      rawImages: [],
      sites: [],
      careContextData: [],
      showABHAModal: false,
      showCustomFieldsDataModal: false,
      neuboPopup: null,
      previousReports: [],
      showAxialReadingsModal: false,
      biometryData: null,
      showKeratometryReadingsModal: false,
      showReportFormatModal: false,
      isGeneratingBiometryReport: false,
      myopiaReport: null,
      isGeneratingMyopiaReport: false,
      reportPollingInterval: null,
      myopiaReportPollingInterval: null,
      showAmendmentReasonModal: false,
      amendmentReason: "",
      lastNotifiedBiometryReportId: null,
      lastNotifiedMyopiaReportId: null,
      hasLogo: false,
      siteLogo: "",
      siteName: "",
      showMyopiaPredictiveGraphModal: false,
      myopiaPredictiveData: null,
      myopiaCurrentRef: null,
      myopiaSelectedItems: null,
      myopiaHistoricalExams: null,
      showRefractionChoiceModal: false,
      myopiaRefractionType: "objective",
      isEditingSubjectiveRefraction: false,
      isSavingSubjectiveRefraction: false,
      subjectiveRefractionDraft: {
        rightEye: { s: "", c: "", a: "" },
        leftEye: { s: "", c: "", a: "" }
      }
    };
    this.viewImages = this.viewImages.bind(this);
    this.viewVideos = this.viewVideos.bind(this);
    this.openGenerateReportModal = this.openGenerateReportModal.bind(this);
    this.hideGenerateReportModal = this.hideGenerateReportModal.bind(this);
    this.hideGenerateReportWithoutImagesModal = this.hideGenerateReportWithoutImagesModal.bind(
      this
    );
    this.hideEditExamDetailsModal = this.hideEditExamDetailsModal.bind(this);
    this.toggleEditPatientModal = this.toggleEditPatientModal.bind(this);
    this.viewReport = this.viewReport.bind(this);
    this.viewAIReport = this.viewAIReport.bind(this);
    this.resetList = this.resetList.bind(this);
    this.editAttribute = this.editAttribute.bind(this);
    this.updateValue = this.updateValue.bind(this);
    this.startGrading = this.startGrading.bind(this);
    this.startGradingWithoutImages = this.startGradingWithoutImages.bind(this);
    this.setTab = this.setTab.bind(this);
    this.zipExam = this.zipExam.bind(this);
    this.download = this.download.bind(this);
    this.onSlideItemLoad = this.onSlideItemLoad.bind(this);
    this.onInit = this.onInit.bind(this);
    this.onAfterSlide = this.onAfterSlide.bind(this);
    this.viewGlaucomaReport = this.viewGlaucomaReport.bind(this);
    this.viewEyrisReport = this.viewEyrisReport.bind(this);
    this.viewMediosAIReport = this.viewMediosAIReport.bind(this);
    this.viewPreviousReport = this.viewPreviousReport.bind(this);
    this.groupAndSortImages = this.groupAndSortImages.bind(this);
    this.toggleSegment = this.toggleSegment.bind(this);
    this.toggleSegmentEdited = this.toggleSegmentEdited.bind(this);
    this.renderImagesByDate = this.renderImagesByDate.bind(this);
    this.toggleABHAModal = this.toggleABHAModal.bind(this);
    this.toggleCustomFieldsDataModal = this.toggleCustomFieldsDataModal.bind(
      this
    );
    this.toggleAxialReadingsModal = this.toggleAxialReadingsModal.bind(this);
    this.toggleKeratometryReadingsModal = this.toggleKeratometryReadingsModal.bind(
      this
    );
    this.toggleReportFormatModal = this.toggleReportFormatModal.bind(this);
    this.handleStartGrading = this.handleStartGrading.bind(this);
    this.generateBiometryReport = this.generateBiometryReport.bind(this);
    this.handleSimpleReportSelect = this.handleSimpleReportSelect.bind(this);
    this.handleMyopiaReportSelect = this.handleMyopiaReportSelect.bind(this);
    this.generateMyopiaReportWithSelection = this.generateMyopiaReportWithSelection.bind(
      this
    );
    this.closeMyopiaPredictiveGraphModal = this.closeMyopiaPredictiveGraphModal.bind(
      this
    );
    this.calculateAge = this.calculateAge.bind(this);
    this.viewMyopiaReport = this.viewMyopiaReport.bind(this);
    this.toggleAmendmentReasonModal = this.toggleAmendmentReasonModal.bind(
      this
    );
    this.handleAmendmentReasonSubmit = this.handleAmendmentReasonSubmit.bind(
      this
    );
    this.hasSubjectiveRefraction = this.hasSubjectiveRefraction.bind(this);
    this.startEditSubjectiveRefraction = this.startEditSubjectiveRefraction.bind(
      this
    );
    this.cancelEditSubjectiveRefraction = this.cancelEditSubjectiveRefraction.bind(
      this
    );
    this.handleSubjectiveRefractionChange = this.handleSubjectiveRefractionChange.bind(
      this
    );
    this.saveSubjectiveRefraction = this.saveSubjectiveRefraction.bind(this);
    this.openRefractionChoiceModal = this.openRefractionChoiceModal.bind(this);
    this.closeRefractionChoiceModal = this.closeRefractionChoiceModal.bind(
      this
    );
    this.handleRefractionTypeSelect = this.handleRefractionTypeSelect.bind(
      this
    );
  }

  componentDidMount() {
    // Check if location.state exists, if not redirect or handle gracefully
    if (!this.props?.location?.state?.exam) {
      console.error(
        "ExamDetails: No exam data in location.state. Redirecting..."
      );
      this.props.history?.push?.("/exam-data");
      return;
    }

    const examId = this.props?.location?.state?.exam?.examDetails?.id;
    if (!examId) {
      console.error("ExamDetails: No exam ID available. Redirecting...");
      this.props.history?.push?.("/exam-data");
      return;
    }

    getAuthenticatedData(
      sessionStorage.getItem("domain") + "/api/abdm/getCareContexts/" + examId
    ).then(res => {
      this.setState({ careContextData: res.data });
    });
    this.resetList();
    this.updateValue();
    // Refresh report data when window becomes active (e.g., when navigating back from GraderFlow)
    this.handleWindowFocus = () => {
      this.resetList();
    };
    window.addEventListener("focus", this.handleWindowFocus);
    getAuthenticatedData(sessionStorage.getItem("domain") + getSites).then(
      res => {
        this.setState({
          sites: res?.data
        });
        // Fetch site logo if available
        const exam = this.props?.location?.state?.exam;
        if (exam?.patientDetails?.siteId) {
          const siteArray = res?.data?.map?.(el => el.siteId);
          let index = 0;
          if (siteArray.includes(exam.patientDetails.siteId)) {
            index = siteArray.indexOf(exam.patientDetails.siteId);
          }
          this.setState({
            siteName: res.data[index]?.siteName || "",
            hasLogo: res.data[index]?.hasLogo || false
          });

          // Fetch logo if site has one
          if (res.data[index]?.hasLogo) {
            getAuthenticatedData(
              sessionStorage.getItem("domain") +
                getSiteLogo +
                "/" +
                exam.patientDetails.siteId
            ).then(
              result => {
                this.setState({ siteLogo: result.data });
              },
              () => {
                // Error fetching logo, continue without it
                console.log("Failed to fetch site logo");
              }
            );
          }
        }
      }
    );
    this.state.userResults.then(result => {
      if (result?.data?.roles?.includes("DOCTOR")) {
        this.setState({ isDoctor: true });
      }
    });
    let mrn = this.props?.location?.state?.exam?.patientDetails?.mrn;
    let firstName = this.props?.location?.state?.exam?.patientDetails
      ?.firstName;
    let lastName = this.props?.location?.state?.exam?.patientDetails?.lastName;
    getAuthenticatedData(
      sessionStorage.getItem("domain") + getImages + "/" + examId
    ).then(result => {
      let images,
        editedImages = [];
      this.setState({ rawImages: result });
      images = result?.data?.fopImages?.["STANDARD"]
        .concat(result?.data?.aimImages?.["STANDARD"])
        .concat(result?.data?.pslImages?.["STANDARD"])
        .concat(result?.data?.otherImages?.["STANDARD"])
        .concat(result?.data?.pristineImages?.["STANDARD"])
        .concat(result?.data?.obmImages?.["STANDARD"])
        .concat(result?.data?.instaZImages?.["STANDARD"])
        .concat(result?.data?.instaZMImages?.["STANDARD"] || [])
        .concat(result?.data?.instaKCImages?.["STANDARD"])
        .concat(result?.data?.neuboImages?.["STANDARD"] || []);
      editedImages = result?.data?.fopImages?.["EDITED"]
        .concat(result?.data?.aimImages?.["EDITED"])
        .concat(result?.data?.pslImages?.["EDITED"])
        .concat(result?.data?.otherImages?.["EDITED"])
        .concat(result?.data?.pristineImages?.["EDITED"])
        .concat(result?.data?.obmImages?.["EDITED"])
        .concat(result?.data?.instaZImages?.["EDITED"])
        .concat(result?.data?.instaZMImages?.["EDITED"] || [])
        .concat(result?.data?.instaKCImages?.["EDITED"])
        .concat(result?.data?.neuboImages?.["EDITED"] || []);
      let imagesThumbnails = images?.map(image => image.thumbnailPath);
      let imageCaptions = images?.concat(editedImages)?.map(
        image =>
          `<h4 className="img-caption-heading">
            ${mrn +
              " - " +
              firstName +
              " " +
              lastName +
              " - " +
              (image.laterality === "LEFT"
                ? this.t(T_EXAMS.examDetails.generateReport.leftEye)
                : this.t(T_EXAMS.examDetails.generateReport.rightEye))}
          </h4>`
      );
      this.setState({
        images: imagesThumbnails,
        imagesBig: images?.concat(editedImages).map(image => image.path),
        small: images,
        smallEdited: editedImages,
        editedImages: editedImages?.map(image => image.thumbnailPath),
        isLoaded: true,
        imageCaptions
      });
    });
    getAuthenticatedData(
      sessionStorage.getItem("domain") + getVideos + "/" + examId
    ).then(result => {
      let videos = result?.data?.map?.(video => video.path);
      let videoThumbnails = result?.data?.map?.(video => video.thumbnailPath);
      this.setState({
        videos,
        videoThumbnails
      });
    });
    this.setState({ report: this.props?.location?.state?.exam?.report });
    // this.state.userResults.then(
    //   result => {
    //     this.setState({ isLoaded: true });
    //     if (result?.data?.roles?.includes("USER_ADMIN")) {
    //       this.resetList();
    //     }
    //   },
    //   () => {
    //     this.setState({ isLoaded: true });
    //   }
    // );
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  componentWillUnmount() {
    // Clean up the window focus event listener
    if (this.handleWindowFocus) {
      window.removeEventListener("focus", this.handleWindowFocus);
    }
    // Clean up polling intervals
    if (this.state.reportPollingInterval) {
      clearInterval(this.state.reportPollingInterval);
    }
    if (this.state.myopiaReportPollingInterval) {
      clearInterval(this.state.myopiaReportPollingInterval);
    }
  }

  onInit() {
    this.setState({ OneSecondOver: true });
  }

  resetList() {
    const examId =
      this.state.examId ||
      this.state.examDetails?.id ||
      this?.props?.location?.state?.exam?.examDetails?.id;

    if (!examId) {
      console.error("resetList: No exam ID available");
      return;
    }

    getAuthenticatedData(
      sessionStorage.getItem("domain") + getExamDetails + "/" + examId
    ).then(result => {
      // Sort previousReports by reportDate in reverse chronological order (newest first)
      const previousReports = (result?.data?.previousReports || []).sort(
        (a, b) => {
          const dateA = a.reportDate || 0;
          const dateB = b.reportDate || 0;
          return dateB - dateA; // Descending order (newest first)
        }
      );

      this.setState({
        report: result?.data?.report,
        patientDetails: result?.data?.patientDetails,
        examDetails: result?.data?.examDetails,
        orderingProvider: result?.data?.orderingProvider,
        visionAssessment: result?.data?.visionAssessment,
        previousReports: previousReports,
        myopiaReport: result?.data?.myopiaReport || null
      });

      return {
        previousReports,
        myopiaReport: result?.data?.myopiaReport || null
      };
    });
  }

  /**
   * Polls the server to check if a biometry report is available
   * Stops polling when report is found or after max attempts
   */
  pollForBiometryReport() {
    if (!this.state.reportPollingInterval) {
      return; // Polling was stopped
    }

    // Get exam ID from state (available after resetList) or from location.state
    const examId =
      this.state.examDetails?.id ||
      this?.props?.location?.state?.exam?.examDetails?.id;

    if (!examId) {
      console.error("Cannot poll for biometry report: exam ID not available");
      clearInterval(this.state.reportPollingInterval);
      this.setState({ reportPollingInterval: null });
      return;
    }

    getAuthenticatedData(
      sessionStorage.getItem("domain") + getExamDetails + "/" + examId
    )
      .then(result => {
        const report = result?.data?.report;
        const currentReport = this.state.report;

        // Check if a new biometry report exists in the regular report object
        if (report) {
          // Check if report is new or has changed
          const isNewReport =
            !currentReport ||
            (report.id && report.id !== currentReport?.id) ||
            (report.reportDate &&
              report.reportDate !== currentReport?.reportDate);

          // Only show notification if this is a truly new report we haven't notified about yet
          const reportIdentifier = report.id || report.reportDate;
          const hasNotifiedForThisReport =
            reportIdentifier &&
            this.state.lastNotifiedBiometryReportId === reportIdentifier;

          if (isNewReport && !hasNotifiedForThisReport) {
            console.log("Biometry report is now available");
            clearInterval(this.state.reportPollingInterval);
            this.setState({
              report: report,
              reportPollingInterval: null,
              lastNotifiedBiometryReportId: reportIdentifier
            });
            toast.success("Biometry report is now available.");
            return;
          }
        }
      })
      .catch(error => {
        console.error("Error polling for biometry report:", error);
        // Continue polling even on error
      });
  }

  /**
   * Polls the server to check if a myopia report is available
   * Stops polling when report is found or after max attempts
   */
  pollForMyopiaReport() {
    if (!this.state.myopiaReportPollingInterval) {
      return; // Polling was stopped
    }

    // Get exam ID from state (available after resetList) or from location.state
    const examId =
      this.state.examDetails?.id ||
      this?.props?.location?.state?.exam?.examDetails?.id;

    if (!examId) {
      console.error("Cannot poll for myopia report: exam ID not available");
      clearInterval(this.state.myopiaReportPollingInterval);
      this.setState({ myopiaReportPollingInterval: null });
      return;
    }

    getAuthenticatedData(
      sessionStorage.getItem("domain") + getExamDetails + "/" + examId
    )
      .then(result => {
        const myopiaReport = result?.data?.myopiaReport || null;

        // Check if myopia report is now available
        if (myopiaReport) {
          const currentMyopiaReport = this.state.myopiaReport;

          // Check if report is new or has changed
          const isNewReport =
            !currentMyopiaReport ||
            (myopiaReport.id && myopiaReport.id !== currentMyopiaReport?.id) ||
            (myopiaReport.generatedDate &&
              myopiaReport.generatedDate !==
                currentMyopiaReport?.generatedDate);

          // Only show notification if this is a truly new report we haven't notified about yet
          const reportIdentifier =
            myopiaReport.id || myopiaReport.generatedDate;
          const hasNotifiedForThisReport =
            reportIdentifier &&
            this.state.lastNotifiedMyopiaReportId === reportIdentifier;

          if (isNewReport && !hasNotifiedForThisReport) {
            console.log("Myopia report is now available");
            clearInterval(this.state.myopiaReportPollingInterval);
            this.setState({
              myopiaReport: myopiaReport,
              myopiaReportPollingInterval: null,
              lastNotifiedMyopiaReportId: reportIdentifier
            });
            toast.success("Myopia report is now available.");
            return;
          }
        }
      })
      .catch(error => {
        console.error("Error polling for myopia report:", error);
        // Continue polling even on error
      });
  }

  viewMyopiaReport() {
    // Get exam ID from state (available after resetList) or from location.state
    const examId =
      this.state.examDetails?.id ||
      this?.props?.location?.state?.exam?.examDetails?.id;

    if (!examId) {
      toast.error(this.t(T_EXAMS.toast.tryAgainAfterSometime));
      return;
    }

    getAuthenticatedData(
      sessionStorage.getItem("domain") + getMyopiaReportLink + `/${examId}`
    ).then(
      result => {
        // Handle different response structures
        if (result?.status?.statusCode === "OK" && result?.data) {
          window.open(result.data, "_blank");
        } else if (result?.data) {
          // If data exists but no status wrapper, open directly
          window.open(result.data, "_blank");
        } else {
          toast.error(this.t(T_EXAMS.toast.tryAgainAfterSometime));
        }
      },
      error => {
        console.error("Error fetching myopia report:", error);
        toast.error(this.t(T_EXAMS.toast.tryAgainAfterSometime));
        this.setState({
          isLoaded: true
        });
      }
    );
  }

  toggleKeratometryReadingsModal() {
    this.setState({
      showKeratometryReadingsModal: !this.state.showKeratometryReadingsModal
    });
  }

  toggleAxialReadingsModal() {
    this.setState({
      showAxialReadingsModal: !this.state.showAxialReadingsModal
    });
  }

  toDataURL(url) {
    return fetch(url)
      .then(response => {
        return response.blob();
      })
      .then(blob => {
        return URL.createObjectURL(blob);
      });
  }
  async download(url) {
    var link = document.createElement("a");
    link.href = await this.toDataURL(url);
    link.download = Math.floor(100000 + Math.random() * 900000);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  onSlideItemLoad() {
    wheelzoom($(".lg-current").find(".lg-image")[0]);
  }

  onAfterSlide() {
    document
      .querySelectorAll("img")
      .forEach(el => el.dispatchEvent(new CustomEvent("wheelzoom.reset")));
  }

  toggleReportFormatModal() {
    this.setState({ showReportFormatModal: !this.state.showReportFormatModal });
  }

  calculateAge(dateOfBirth) {
    return Math.floor((new Date() - new Date(dateOfBirth)) / 3.15576e10);
  }

  async generateBiometryReport(amendmentReason = null) {
    this.setState({ isGeneratingBiometryReport: true });

    try {
      console.log("Starting biometry report generation...");
      console.log("Biometry data:", this.state.biometryData);
      console.log("Current userId:", this.state.userId);

      // Check if required data is available
      if (!this.state.biometryData) {
        throw new Error("Biometry data is not available");
      }

      // Get exam data from state or location.state
      const exam =
        this.props?.location?.state?.exam ||
        (this.state.patientDetails && this.state.examDetails
          ? {
              examDetails: this.state.examDetails,
              patientDetails: this.state.patientDetails
            }
          : null);

      if (!exam) {
        throw new Error("Exam data is not available");
      }

      // Get userId if not available
      let userId = this.state.userId;
      if (!userId) {
        console.log("UserId not in state, fetching from API...");
        const userResult = await getAuthenticatedData(
          sessionStorage.getItem("domain") + getUser
        );
        userId = userResult?.data?.userId;

        if (!userId) {
          throw new Error("Unable to get user ID from API");
        }

        // Update state with userId for future use
        this.setState({ userId });
        console.log("Retrieved userId:", userId);
      }

      console.log("Generating PDF...");

      // Generate PDF
      const blob = await pdf(
        <BiometryPDF
          exam={exam}
          biometryData={this.state.biometryData}
          siteName={this.state.siteName}
          hasLogo={this.state.hasLogo}
          siteLogo={this.state.siteLogo}
        />
      ).toBlob();

      console.log("PDF generated successfully, blob size:", blob.size);

      // Prepare form data for API call
      // Replace the data object in generateBiometryReport with this corrected version:

      // Prepare form data matching GraderFlow.js exactly
      const data = {
        examId: exam.examDetails.id,
        localId:
          (exam.examDetails.localId || exam.examDetails.id) +
          "-biometry-report",
        patientId: exam.patientDetails.id,
        leftEyeDiagnosis: {
          diagnoses: ["NA"] // Use the same format as GraderFlow for "Not Applicable"
        },
        rightEyeDiagnosis: {
          diagnoses: ["NA"] // Use the same format as GraderFlow for "Not Applicable"
        },
        prescriptionTreatment: "", // Required empty string
        imageIds: [], // Empty array for biometry (no images)
        reportingDoctorId: userId,
        referRequired: false, // Boolean value
        includeVAReading1: false, // Set to true to satisfy API validation since imageIds is empty
        includeVAReading2: false, // Boolean for vision assessment reading 2
        comments: "", // Empty string to match GraderFlow default,
        biometryData: this.state.biometryData
      };

      // Add amendment reason if provided (only if report exists)
      if (amendmentReason && amendmentReason.trim()) {
        data.amendmentReason = amendmentReason.trim();
      }

      console.log("API payload:", data);

      const formData = new FormData();
      formData.append(
        "dto",
        new Blob([JSON.stringify(data)], { type: "application/json" })
      );
      formData.append("pdf", blob);

      console.log("Calling API...");

      // Call the generate report API
      const result = await postAuthenticatedFormData(
        sessionStorage.getItem("domain") + gradeExam,
        formData
      );

      console.log("API response status:", result.status);

      if (result.status === 200) {
        console.log("Report generated successfully");
        toast.success("Biometry report has been generated successfully.");

        // Reset the notification tracking to allow notification when report becomes available
        this.setState({ lastNotifiedBiometryReportId: null });

        // Start polling for report availability (poll for up to 60 seconds)
        let attemptCount = 0;
        const maxAttempts = 30; // 30 attempts * 2 seconds = 60 seconds max
        const pollingInterval = setInterval(() => {
          attemptCount++;
          if (attemptCount >= maxAttempts) {
            clearInterval(pollingInterval);
            this.setState({ reportPollingInterval: null });
            console.log(
              "Stopped polling for biometry report - max attempts reached"
            );
            return;
          }
          this.pollForBiometryReport();
        }, 2000); // Poll every 2 seconds

        this.setState({ reportPollingInterval: pollingInterval });

        // Refresh exam details to update UI with new report
        this.resetList();
      } else {
        console.log("API returned non-200 status");
        const resp = await result.json();
        console.log("API error response:", resp);

        if (
          resp.status.statusCode !== "OK" &&
          resp.status.statusCode !== "FORBIDDEN" &&
          resp.status.statusCode !== "NOT_AUTHORIZED"
        ) {
          toast.error(resp.status.message || "Failed to generate report");
        } else {
          toast.error("Failed to generate biometry report. Please try again.");
        }
      }
    } catch (error) {
      console.error("Error generating biometry report:", error);
      console.error("Error stack:", error.stack);

      // More specific error messages
      if (error.message.includes("PDF")) {
        toast.error(
          "Failed to generate PDF. Please check the data and try again."
        );
      } else if (error.message.includes("Network")) {
        toast.error(
          "Network error. Please check your connection and try again."
        );
      } else if (
        error.message.includes("not available") ||
        error.message.includes("user")
      ) {
        toast.error(
          "User information not available. Please refresh the page and try again."
        );
      } else {
        toast.error("Failed to generate biometry report. Please try again.");
      }
    } finally {
      this.setState({ isGeneratingBiometryReport: false });
    }
  }

  handleStartGrading() {
    // Get exam data from state or location.state
    const exam =
      this.props?.location?.state?.exam ||
      (this.state.patientDetails && this.state.examDetails
        ? {
            examDetails: this.state.examDetails,
            patientDetails: this.state.patientDetails
          }
        : null);

    if (!exam || !exam.patientDetails?.dateOfBirth) {
      toast.error("Patient information not available");
      return;
    }

    const age = this.calculateAge(exam.patientDetails.dateOfBirth);

    if (age >= 18) {
      // Patient is 18 or older
      // Check if a report already exists (has an ID or is not empty)
      const hasExistingReport =
        this.state.report &&
        (this.state.report.id || Object.keys(this.state.report).length > 0);

      if (hasExistingReport) {
        // Show amendment reason modal
        this.setState({ showAmendmentReasonModal: true });
      } else {
        // No existing report, generate report directly
        this.generateBiometryReport();
      }
    } else {
      // Patient is under 18, show format selection modal
      this.toggleReportFormatModal();
    }
  }

  handleSimpleReportSelect() {
    // Check if a report already exists (has an ID or is not empty)
    const hasExistingReport =
      this.state.report &&
      (this.state.report.id || Object.keys(this.state.report).length > 0);

    if (hasExistingReport) {
      // Show amendment reason modal
      this.setState({ showAmendmentReasonModal: true });
    } else {
      // No existing report, proceed directly
      this.generateBiometryReport();
    }
  }

  toggleAmendmentReasonModal() {
    this.setState({
      showAmendmentReasonModal: !this.state.showAmendmentReasonModal,
      amendmentReason: ""
    });
  }

  handleAmendmentReasonSubmit() {
    // Validate amendment reason
    if (!this.state.amendmentReason || !this.state.amendmentReason.trim()) {
      toast.error("Please provide an amendment reason");
      return;
    }
    // Proceed with report generation with amendment reason
    const amendmentReason = this.state.amendmentReason.trim();
    this.setState({ showAmendmentReasonModal: false });
    this.generateBiometryReport(amendmentReason);
  }

  async handleMyopiaReportSelect(refractionType = "objective") {
    try {
      // Check if required data is available
      if (!this.state.biometryData) {
        throw new Error("Biometry data is not available");
      }

      if (!this.props.location.state.exam) {
        throw new Error("Exam data is not available");
      }

      // Picks the objective or subjective refraction block for an eye based on the chosen reading.
      const refractionFor = eye =>
        refractionType === "subjective"
          ? eye?.subjectiveRefractionData
          : eye?.refractionData;

      const exam = this.props.location.state.exam;
      const patientDetails = exam.patientDetails;
      const biometryData = this.state.biometryData;

      // Fetch historical exams for growth trend data
      let historicalExams = [];
      try {
        // Always use OBM for deviceType
        const deviceType = "OBM";

        // Get siteId from patientDetails
        const siteId = patientDetails?.siteId;

        // Build API URL with deviceType and siteId
        const apiUrl =
          sessionStorage.getItem("domain") +
          getPatientWithExams +
          `/${patientDetails.mrn}?deviceType=${deviceType}` +
          (siteId ? `&siteId=${siteId}` : "");

        const patientExamsResult = await getAuthenticatedData(apiUrl);
        historicalExams = patientExamsResult?.data?.exams || [];
      } catch (error) {
        console.warn("Could not fetch historical exams:", error);
      }

      // Build growth data from historical exams
      const growthData = [];
      const currentGraphData = [];

      // Build predictive curve data
      const predictiveCurveData = [];

      // Add current exam
      const currentExamDate = convertEpochToDate(
        exam.examDetails.examDate || new Date().getTime()
      );
      const currentAge = this.calculateAge(patientDetails.dateOfBirth);
      const alRE = this.state.biometryData?.rightEye?.axialData?.al;
      const alLE = this.state.biometryData?.leftEye?.axialData?.al;

      growthData.push({
        date: currentExamDate,
        alRE: alRE ? alRE.toFixed(2) : "",
        alLE: alLE ? alLE.toFixed(2) : "",
        remarks: ""
      });

      currentGraphData.push({
        age: currentAge,
        r: alRE || null,
        l: alLE || null
      });

      // Calculate SEQ for predictive curve (allow s=0, c=0; use current exam's refraction)
      const currentRERefraction = refractionFor(biometryData?.rightEye);
      const currentLERefraction = refractionFor(biometryData?.leftEye);
      const seqRE =
        currentRERefraction?.s != null && currentRERefraction?.c != null
          ? parseFloat(currentRERefraction.s) +
            parseFloat(currentRERefraction.c) / 2
          : null;
      const seqLE =
        currentLERefraction?.s != null && currentLERefraction?.c != null
          ? parseFloat(currentLERefraction.s) +
            parseFloat(currentLERefraction.c) / 2
          : null;

      predictiveCurveData.push({
        age: currentAge,
        r: seqRE,
        l: seqLE,
        rate: 1.0
      });

      // Current exam as reference for predictive graph (LE/RE = current patient values)
      const currentRef = { age: currentAge, l: seqLE, r: seqRE };

      // Add historical exams (sorted by date, newest first)
      const sortedHistoricalExams = historicalExams
        .filter(
          e =>
            e.examDetails?.id !== exam.examDetails.id &&
            e.biometryData &&
            (e.biometryData.rightEye?.axialData?.al ||
              e.biometryData.leftEye?.axialData?.al)
        )
        .sort((a, b) => {
          const dateA = a.examDetails?.examDate || 0;
          const dateB = b.examDetails?.examDate || 0;
          return dateB - dateA; // Newest first
        })
        .slice(0, 4); // Limit to 4 most recent visits (1 current + 4 historical = 5 total)

      sortedHistoricalExams.forEach(historicalExam => {
        // Calculate age at the time of the historical exam
        const examDateEpoch =
          historicalExam.examDetails?.examDate || new Date().getTime();
        const examAge = Math.floor(
          (examDateEpoch - new Date(patientDetails.dateOfBirth).getTime()) /
            3.15576e10
        );
        const histAlRE = historicalExam.biometryData?.rightEye?.axialData?.al;
        const histAlLE = historicalExam.biometryData?.leftEye?.axialData?.al;

        if (histAlRE || histAlLE) {
          const examDate = convertEpochToDate(
            historicalExam.examDetails?.examDate || new Date().getTime()
          );
          growthData.push({
            date: examDate,
            alRE: histAlRE ? histAlRE.toFixed(2) : "",
            alLE: histAlLE ? histAlLE.toFixed(2) : "",
            remarks: ""
          });

          currentGraphData.push({
            age: examAge,
            r: histAlRE || null,
            l: histAlLE || null
          });
        }

        // Add to predictive curve data if refraction data exists
        const histR = refractionFor(historicalExam.biometryData?.rightEye);
        const histL = refractionFor(historicalExam.biometryData?.leftEye);
        const histSeqRE =
          histR?.s != null && histR?.c != null
            ? parseFloat(histR.s) + parseFloat(histR.c) / 2
            : null;
        const histSeqLE =
          histL?.s != null && histL?.c != null
            ? parseFloat(histL.s) + parseFloat(histL.c) / 2
            : null;

        if (histSeqRE !== null || histSeqLE !== null) {
          predictiveCurveData.push({
            age: examAge,
            r: histSeqRE,
            l: histSeqLE,
            rate: 1.0
          });
        }
      });

      // Show the predictive graph modal
      this.setState({
        showMyopiaPredictiveGraphModal: true,
        myopiaPredictiveData: predictiveCurveData,
        myopiaCurrentRef: currentRef,
        myopiaRefractionType: refractionType,
        myopiaHistoricalExams: historicalExams // Store historical exams to avoid re-fetching
      });
    } catch (error) {
      console.error("Error preparing myopia report:", error);
      toast.error("Failed to prepare myopia report. Please try again.");
    }
  }

  closeMyopiaPredictiveGraphModal() {
    this.setState({
      showMyopiaPredictiveGraphModal: false,
      myopiaPredictiveData: null,
      myopiaCurrentRef: null,
      myopiaSelectedItems: null,
      myopiaHistoricalExams: null
    });
  }

  async generateMyopiaReportWithSelection(
    selectedItems,
    predictiveData,
    currentRef
  ) {
    this.setState({
      isGeneratingMyopiaReport: true,
      myopiaSelectedItems: selectedItems
    });

    try {
      // Check if required data is available
      if (!this.state.biometryData) {
        throw new Error("Biometry data is not available");
      }

      if (!this.props.location.state.exam) {
        throw new Error("Exam data is not available");
      }

      if (!predictiveData || predictiveData.length === 0) {
        throw new Error("Predictive data is not available");
      }

      const exam = this.props.location.state.exam;
      const patientDetails = exam.patientDetails;
      const biometryData = this.state.biometryData;

      // Use historical exams from state (already fetched in handleMyopiaReportSelect)
      // This avoids making a redundant API call
      const historicalExams = this.state.myopiaHistoricalExams || [];

      // Build growth data from historical exams
      const growthData = [];
      const currentGraphData = [];

      // Add current exam
      const currentExamDate = convertEpochToDate(
        exam.examDetails.examDate || new Date().getTime()
      );
      const currentAge = this.calculateAge(patientDetails.dateOfBirth);
      const alRE = this.state.biometryData?.rightEye?.axialData?.al;
      const alLE = this.state.biometryData?.leftEye?.axialData?.al;

      growthData.push({
        date: currentExamDate,
        alRE: alRE ? alRE.toFixed(2) : "",
        alLE: alLE ? alLE.toFixed(2) : "",
        remarks: ""
      });

      currentGraphData.push({
        age: currentAge,
        r: alRE || null,
        l: alLE || null
      });

      // Add historical exams (sorted by date, newest first)
      const sortedHistoricalExams = historicalExams
        .filter(
          e =>
            e.examDetails?.id !== exam.examDetails.id &&
            e.biometryData &&
            (e.biometryData.rightEye?.axialData?.al ||
              e.biometryData.leftEye?.axialData?.al)
        )
        .sort((a, b) => {
          const dateA = a.examDetails?.examDate || 0;
          const dateB = b.examDetails?.examDate || 0;
          return dateB - dateA; // Newest first
        })
        .slice(0, 4); // Limit to 4 most recent visits (1 current + 4 historical = 5 total)

      sortedHistoricalExams.forEach(historicalExam => {
        const examDate = convertEpochToDate(
          historicalExam.examDetails?.examDate || new Date().getTime()
        );
        // Calculate age at the time of the historical exam
        const examDateEpoch =
          historicalExam.examDetails?.examDate || new Date().getTime();
        const examAge = Math.floor(
          (examDateEpoch - new Date(patientDetails.dateOfBirth).getTime()) /
            3.15576e10
        );
        const histAlRE = historicalExam.biometryData?.rightEye?.axialData?.al;
        const histAlLE = historicalExam.biometryData?.leftEye?.axialData?.al;

        if (histAlRE || histAlLE) {
          growthData.push({
            date: examDate,
            alRE: histAlRE ? histAlRE.toFixed(2) : "",
            alLE: histAlLE ? histAlLE.toFixed(2) : "",
            remarks: ""
          });

          currentGraphData.push({
            age: examAge,
            r: histAlRE || null,
            l: histAlLE || null
          });
        }
      });

      // Build at most 2 rows for PDF: row 1 = current exam, row 2 = last exam not from today
      const currentExamEpoch =
        exam.examDetails?.examDate || new Date().getTime();
      const isSameCalendarDay = (epochA, epochB) =>
        new Date(epochA).toDateString() === new Date(epochB).toDateString();
      const pdfGrowthData = [growthData[0]]; // Row 1: always current exam
      const lastNotToday = sortedHistoricalExams.find(
        e => !isSameCalendarDay(currentExamEpoch, e.examDetails?.examDate || 0)
      );
      if (lastNotToday) {
        const examDate = convertEpochToDate(
          lastNotToday.examDetails?.examDate || new Date().getTime()
        );
        const histAlRE = lastNotToday.biometryData?.rightEye?.axialData?.al;
        const histAlLE = lastNotToday.biometryData?.leftEye?.axialData?.al;
        pdfGrowthData.push({
          date: examDate,
          alRE: histAlRE ? histAlRE.toFixed(2) : "",
          alLE: histAlLE ? histAlLE.toFixed(2) : "",
          remarks: ""
        });
      }

      // Reverse to show oldest first in table (kept for reportData if needed)
      growthData.reverse();

      // Use the predictive data passed as parameter (not from state, as state may be cleared)
      const predictiveCurveData = predictiveData;

      // Generate graphs with selected items
      const gender = patientDetails.gender || "MALE";
      const growthGraphImage = await generateGrowthCurveGraph(
        currentGraphData,
        gender
      );
      const predictiveGraphImage = await generatePredictiveCurveGraph(
        predictiveCurveData,
        {
          currentRef: currentRef,
          selectedItems: {
            includeRealPatientData: selectedItems.includeRealPatientData,
            selectedTreatments: selectedItems.selectedTreatments
          }
        }
      );

      // Modal is already closed by this point (closed immediately on button click)
      // Build sections data for reportData
      const R = biometryData?.rightEye || null;
      const L = biometryData?.leftEye || null;

      // Use the refraction reading (objective/subjective) chosen for this report.
      const refractionType = this.state.myopiaRefractionType || "objective";
      const RRefraction =
        refractionType === "subjective"
          ? R?.subjectiveRefractionData
          : R?.refractionData;
      const LRefraction =
        refractionType === "subjective"
          ? L?.subjectiveRefractionData
          : L?.refractionData;

      const seqREValue =
        RRefraction?.s != null && RRefraction?.c != null
          ? (parseFloat(RRefraction.s) + parseFloat(RRefraction.c) / 2).toFixed(
              2
            )
          : "";
      const seqLEValue =
        LRefraction?.s != null && LRefraction?.c != null
          ? (parseFloat(LRefraction.s) + parseFloat(LRefraction.c) / 2).toFixed(
              2
            )
          : "";

      const sections = [
        {
          title: "Optical Biometry",
          rows: [
            [
              "Axial Length",
              this.fmt(R?.axialData?.al, 2),
              this.fmt(L?.axialData?.al, 2)
            ],
            ["AL/CR", this.fmt(R?.alCr, 2), this.fmt(L?.alCr, 2)],
            ["SEQ", seqREValue, seqLEValue]
          ]
        },
        {
          title: "Keratometry",
          rows: [
            [
              "K1",
              this.safe(R?.keratometryData?.k1, ""),
              this.safe(L?.keratometryData?.k1, "")
            ],
            [
              "K2",
              this.safe(R?.keratometryData?.k2, ""),
              this.safe(L?.keratometryData?.k2, "")
            ],
            [
              "AST",
              this.safe(R?.keratometryData?.ast, ""),
              this.safe(L?.keratometryData?.ast, "")
            ]
          ]
        },
        {
          title:
            refractionType === "subjective"
              ? "Subjective Refraction"
              : "Objective Refraction",
          rows: [
            [
              "Sphere",
              this.safe(RRefraction?.s, ""),
              this.safe(LRefraction?.s, "")
            ],
            [
              "Cylinder",
              this.safe(RRefraction?.c, ""),
              this.safe(LRefraction?.c, "")
            ],
            [
              "Axis",
              this.safe(RRefraction?.a, ""),
              this.safe(LRefraction?.a, "")
            ]
          ]
        }
      ];

      // Generate PDF
      const blob = await pdf(
        <MyopiaPDF
          exam={exam}
          biometryData={biometryData}
          siteName={this.state.siteName}
          hasLogo={this.state.hasLogo}
          siteLogo={this.state.siteLogo}
          growthData={pdfGrowthData}
          currentGraphData={currentGraphData}
          predictiveCurveData={predictiveCurveData}
          growthGraphImage={growthGraphImage}
          predictiveGraphImage={predictiveGraphImage}
          selectedItems={selectedItems}
          refractionType={refractionType}
        />
      ).toBlob();

      // Convert blob to base64
      const base64PDF = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1];
          resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      // Build reportData structure matching MyopiaReportRequestDTO
      const reportData = {
        sections: sections.map(section => ({
          title: section.title,
          rows: section.rows
        })),
        growthData: growthData.map(gd => ({
          date: gd.date,
          alRE: gd.alRE,
          alLE: gd.alLE,
          remarks: gd.remarks || ""
        })),
        currentReadingGraphData: currentGraphData.map(cgd => ({
          age: cgd.age,
          r: cgd.r,
          l: cgd.l
        })),
        predictiveCurveData: predictiveCurveData.map(pcd => ({
          age: pcd.age,
          r: pcd.r,
          l: pcd.l,
          rate: pcd.rate
        }))
      };

      // Prepare request payload
      const requestPayload = {
        myopiaReportLocalId: `${
          exam.examDetails.id
        }-myopia-report-${Date.now()}`,
        base64EncodedPDF: base64PDF,
        examId: exam.examDetails.id,
        generatedDate: new Date().getTime(),
        refractionType: refractionType,
        reportData: reportData
      };

      // Call API
      const result = await postAuthenticatedData(
        sessionStorage.getItem("domain") + addMyopiaReportToExam,
        requestPayload
      );

      if (result.status === 200 || result.status?.statusCode === "OK") {
        toast.success("Myopia report has been generated successfully.");

        // Reset the notification tracking to allow notification when report becomes available
        this.setState({ lastNotifiedMyopiaReportId: null });

        // Start polling for report availability (poll for up to 60 seconds)
        let attemptCount = 0;
        const maxAttempts = 30; // 30 attempts * 2 seconds = 60 seconds max
        const pollingInterval = setInterval(() => {
          attemptCount++;
          if (attemptCount >= maxAttempts) {
            clearInterval(pollingInterval);
            this.setState({ myopiaReportPollingInterval: null });
            console.log(
              "Stopped polling for myopia report - max attempts reached"
            );
            return;
          }
          this.pollForMyopiaReport();
        }, 2000); // Poll every 2 seconds

        this.setState({ myopiaReportPollingInterval: pollingInterval });

        // Refresh exam details to update UI with new report
        this.resetList();
      } else {
        toast.error("Failed to generate myopia report. Please try again.");
      }
    } catch (error) {
      console.error("Error generating myopia report:", error);
      toast.error("Failed to generate myopia report. Please try again.");
    } finally {
      this.setState({ isGeneratingMyopiaReport: false });
    }
  }

  // Helper methods for formatting
  safe = (v, fallback = "") =>
    v === null || v === undefined || Number.isNaN(v) ? fallback : v;

  fmt = (v, digits = 2) => {
    if (v === null || v === undefined || v === "") return "";
    if (typeof v === "string") return v;
    const n = Number(v);
    if (Number.isNaN(n)) return "";
    return n.toFixed(digits);
  };

  toggleSegment(date, segment) {
    this.setState(prevState => ({
      toggledSegments: {
        ...prevState.toggledSegments,
        [date]: segment
      }
    }));
  }

  toggleSegmentEdited(date, segment) {
    this.setState(prevState => ({
      toggledSegmentsEdited: {
        ...prevState.toggledSegmentsEdited,
        [date]: segment
      }
    }));
  }

  renderImagesByDate(date, imagesBySegment) {
    // Use the toggledSegments state to determine which segment to show
    const selectedSegment = this.state.toggledSegments[date] || "POSTERIOR";
    const imagesToShow = imagesBySegment[selectedSegment];

    return (
      <div className="image-grid">
        {imagesToShow.map(image => (
          <a className="gallery-item" href={image.path} key={image.id}>
            <img src={image.thumbnailPath} />
            {this.renderLateralityBadge(image.laterality)}
          </a>
        ))}
      </div>
    );
  }

  zipExam() {
    postAuthenticatedData(
      sessionStorage.getItem("domain") +
        zipExam +
        "/" +
        this.state.examDetails.id
    )
      .then(res => {
        return res.json();
      })
      .then(res => {
        // eslint-disable-next-line no-console
        toast.success(
          this.t(T_EXAMS.toast.examDownloadForPatient, {
            name:
              this.state.patientDetails.firstName +
              (this.state.patientDetails.lastName
                ? " " + this.state.patientDetails.lastName
                : "")
          })
        );
        let interval = setInterval(() => {
          postAuthenticatedData(
            sessionStorage.getItem("domain") +
              getPathForDownload +
              "/" +
              res.data
          )
            .then(res => {
              return res.json();
            })
            .then(res => {
              // eslint-disable-next-line no-console
              if (res.status.statusCode === "OK") {
                clearInterval(interval);
                this.download(res.data);
              }
            });
        }, 1000);
      });
  }

  setTab(tab) {
    this.setState({ selectedTab: tab });
  }

  /**
   * Renders the LE/RE laterality badge overlaid on the bottom-right of an
   * image thumbnail. Used across all device types in the image previews.
   * @param {string} laterality "LEFT" / "RIGHT"
   */
  renderLateralityBadge(laterality) {
    if (!laterality) return null;
    return (
      <div className="image-laterality-badge">
        {laterality === "LEFT" ? "LE" : "RE"}
      </div>
    );
  }

  startGrading() {
    putAuthenticatedData(
      sessionStorage.getItem("domain") +
        assignExam +
        "/" +
        this?.props?.location?.state?.exam?.examDetails?.id
    )
      .then(result => {
        // if (result.status === 200) {
        this.props?.history?.push?.({
          pathname: "/grader-flow",
          state: {
            big: this.state.imagesBig,
            exam: this.props.location.state.exam,
            deviceType: this.props.location.state.deviceType,
            hasAssessment: !!this.state.visionAssessment,
            visionAssessment: this.state.visionAssessment
          }
        });
        // }
        return result.json();
      })
      .then(resp => {
        if (
          resp.status.statusCode !== "OK" &&
          resp.status.statusCode !== "FORBIDDEN" &&
          resp.status.statusCode !== "NOT_AUTHORIZED"
        ) {
          toast.error(resp.status.message);
        }
      });
    // this.props?.history?.push?.({
    //   pathname: "/grader-flow",
    //   state: {
    //     big: this.state.imagesBig,
    //     exam: this.props.location.state.exam,
    //     deviceType: this.props.location.state.deviceType
    //   }
    // });
  }

  updateValue() {
    getAuthenticatedData(
      sessionStorage.getItem("domain") +
        getExamDetails +
        "/" +
        this?.props?.location?.state?.exam?.examDetails?.id
    ).then(result => {
      this.setState({
        ocularHistory: result?.data?.examDetails?.ocularHistory,
        systemicHistory: result?.data?.examDetails?.medicalHistory,
        currentMedication: result?.data?.examDetails?.currentMedication,
        allergies: result?.data?.examDetails?.allergies,
        examState: result?.data?.examDetails?.examState,
        biometryData: result?.data?.biometryData, // Add this line
        selectedTab:
          // OBM exams open on the Biometry Data tab, since the biometry
          // readings (not the images) are what matters for that device.
          result?.data?.examDetails?.deviceType?.includes("OBM") &&
          result?.data?.biometryData
            ? 5
            : (result?.data?.examDetails?.deviceType.includes("INSTAREF") ||
                result?.data?.examDetails?.deviceType.includes("INSTAZ") ||
                result?.data?.examDetails?.deviceType.includes("INSTAZM")) &&
              result?.data?.visionAssessment &&
              result?.data?.images === null
            ? 2
            : 3,
        editableAttributes: {
          ocularHistory: {
            text: "Ocular History",
            enum: "OCULAR_HISTORY",
            currentValue: result?.data?.examDetails?.ocularHistory
          },
          medicalHistory: {
            text: "Systemic History",
            enum: "MEDICAL_HISTORY",
            currentValue: result?.data?.examDetails?.medicalHistory
          },
          currentMedication: {
            text: "Current Medication",
            enum: "CURRENT_MEDICATIONS",
            currentValue: result?.data?.examDetails?.currentMedication
          },
          allergies: {
            text: "Allergies",
            enum: "ALLERGIES",
            currentValue: result?.data?.examDetails?.allergies
          }
        }
      });
    });
  }

  formatBiometryValue(value) {
    if (value === null || value === undefined || value === 0) {
      return "-";
    }
    return value;
  }

  // Format biometry values with units
  formatCCT(value) {
    if (value === null || value === undefined || value === 0) {
      return "-";
    }
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num)) return "-";
    return `${num.toFixed(2)} μm`;
  }

  // CCT in biometry section: value * 1000, 2 decimal places
  formatCCTBiometry(value) {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num)) return "-";
    return `${(num * 1000).toFixed(2)} μm`;
  }

  formatMM(value) {
    if (value === null || value === undefined || value === 0) {
      return "-";
    }
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num)) return "-";
    return `${num.toFixed(2)} mm`;
  }

  // Keratometry: DS/DC only, no angles
  formatKeratometryK1(value) {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    let ds = null;
    if (typeof value === "string") {
      // Parse format like "7.35/45.15D@168°" -> use diopter part only (45.15 DS)
      const parts = value.split("/");
      if (parts.length >= 2) {
        const match = parts[1].match(/([\d.-]+)D/);
        if (match) {
          ds = parseFloat(match[1]);
        }
      }
      if (ds == null || isNaN(ds)) {
        ds = parseFloat(value);
      }
    } else {
      ds = typeof value === "number" ? value : parseFloat(value);
    }
    if (ds == null || isNaN(ds)) return "-";
    return `${ds.toFixed(2)} DS`;
  }

  formatKeratometryK2(value) {
    return this.formatKeratometryK1(value); // Same format as K1
  }

  // Keratometry AST: DC only, no angles
  formatKeratometryAST(value) {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    let dc = null;
    if (typeof value === "string") {
      // Parse format like "-0.65D@168°" -> use cylinder only (e.g. -0.65 DC)
      const match = value.match(/([\d.-]+)D/);
      if (match) {
        dc = parseFloat(match[1]);
      }
      if (dc == null || isNaN(dc)) {
        dc = parseFloat(value);
      }
    } else {
      dc = typeof value === "number" ? value : parseFloat(value);
    }
    if (dc == null || isNaN(dc)) return "-";
    return `${dc.toFixed(2)} DC`;
  }

  formatAvgK(value) {
    if (value === null || value === undefined || value === 0) {
      return "-";
    }
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num)) return "-";
    return `${num.toFixed(2)} mm`;
  }

  formatALCR(value) {
    if (value === null || value === undefined || value === 0) {
      return "-";
    }
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num)) return "-";
    return num.toFixed(2); // No unit
  }

  formatRefractionS(value) {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    // If it's already formatted, return it
    if (typeof value === "string" && value.includes("DS")) {
      return value;
    }
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num)) return "-";
    return `${num.toFixed(2)}DS`;
  }

  formatRefractionC(value) {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    // If it's already formatted, return it
    if (typeof value === "string" && value.includes("DC")) {
      return value;
    }
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num)) return "-";
    return `${num.toFixed(2)} DC`;
  }

  formatRefractionA(value) {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    // If it's already formatted, return it
    if (typeof value === "string" && value.includes("°")) {
      return value;
    }
    const num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num)) return "-";
    return `${num}°`;
  }

  // Returns true when subjective refraction has been entered for at least one eye.
  hasSubjectiveRefraction() {
    const biometryData = this.state.biometryData;
    if (!biometryData) return false;
    const hasValue = eye => {
      const sr = eye?.subjectiveRefractionData;
      if (!sr) return false;
      return [sr.s, sr.c, sr.a].some(v => v !== null && v !== undefined);
    };
    return hasValue(biometryData.rightEye) || hasValue(biometryData.leftEye);
  }

  startEditSubjectiveRefraction() {
    const biometryData = this.state.biometryData || {};
    const toStr = v => (v === null || v === undefined ? "" : String(v));
    const draftFor = eye => ({
      s: toStr(eye?.subjectiveRefractionData?.s),
      c: toStr(eye?.subjectiveRefractionData?.c),
      a: toStr(eye?.subjectiveRefractionData?.a)
    });
    this.setState({
      isEditingSubjectiveRefraction: true,
      subjectiveRefractionDraft: {
        rightEye: draftFor(biometryData.rightEye),
        leftEye: draftFor(biometryData.leftEye)
      }
    });
  }

  cancelEditSubjectiveRefraction() {
    this.setState({
      isEditingSubjectiveRefraction: false,
      subjectiveRefractionDraft: {
        rightEye: { s: "", c: "", a: "" },
        leftEye: { s: "", c: "", a: "" }
      }
    });
  }

  handleSubjectiveRefractionChange(eye, field, value) {
    this.setState(prevState => ({
      subjectiveRefractionDraft: {
        ...prevState.subjectiveRefractionDraft,
        [eye]: {
          ...prevState.subjectiveRefractionDraft[eye],
          [field]: value
        }
      }
    }));
  }

  async saveSubjectiveRefraction() {
    const examId = this?.props?.location?.state?.exam?.examDetails?.id;
    if (!examId) {
      toast.error("Exam ID is not available");
      return;
    }

    const draft = this.state.subjectiveRefractionDraft;
    const parseNum = v => {
      if (v === null || v === undefined || String(v).trim() === "") return null;
      const num = parseFloat(v);
      return isNaN(num) ? null : num;
    };
    const buildEye = eye => ({
      s: parseNum(eye.s),
      c: parseNum(eye.c),
      a: parseNum(eye.a)
    });

    const rightEyePayload = buildEye(draft.rightEye);
    const leftEyePayload = buildEye(draft.leftEye);

    const hasAnyValue = eyePayload =>
      eyePayload.s !== null || eyePayload.c !== null || eyePayload.a !== null;

    if (!hasAnyValue(rightEyePayload) && !hasAnyValue(leftEyePayload)) {
      toast.error(
        "Please enter subjective refraction values for at least one eye"
      );
      return;
    }

    this.setState({ isSavingSubjectiveRefraction: true });

    try {
      const result = await putAuthenticatedData(
        sessionStorage.getItem("domain") +
          addSubjectiveRefraction +
          "/" +
          examId,
        { rightEye: rightEyePayload, leftEye: leftEyePayload }
      );

      if (result.status === 200 || result.status?.statusCode === "OK") {
        // Reflect the saved values locally without re-fetching the whole exam.
        const biometryData = this.state.biometryData || {};
        const applyEye = (eye, payload) => ({
          ...(eye || {}),
          subjectiveRefractionData: payload
        });
        const updatedBiometryData = {
          ...biometryData,
          rightEye: applyEye(biometryData.rightEye, rightEyePayload),
          leftEye: applyEye(biometryData.leftEye, leftEyePayload)
        };
        this.setState({
          biometryData: updatedBiometryData,
          isEditingSubjectiveRefraction: false,
          isSavingSubjectiveRefraction: false
        });
        toast.success("Subjective refraction has been saved.");
      } else {
        this.setState({ isSavingSubjectiveRefraction: false });
        toast.error("Failed to save subjective refraction. Please try again.");
      }
    } catch (error) {
      console.error("Error saving subjective refraction:", error);
      this.setState({ isSavingSubjectiveRefraction: false });
      toast.error("Failed to save subjective refraction. Please try again.");
    }
  }

  // Refraction reading choice (objective vs subjective) for the myopia report flow.
  openRefractionChoiceModal() {
    this.setState({ showRefractionChoiceModal: true });
  }

  closeRefractionChoiceModal() {
    this.setState({ showRefractionChoiceModal: false });
  }

  handleRefractionTypeSelect(refractionType) {
    this.setState({ showRefractionChoiceModal: false });
    this.handleMyopiaReportSelect(refractionType);
  }

  // Helper methods for myopia report
  safe(v, fallback = "") {
    return v === null || v === undefined || Number.isNaN(v) ? fallback : v;
  }

  fmt(v, digits = 2) {
    if (v === null || v === undefined || v === "") return "";
    if (typeof v === "string") return v;
    const n = Number(v);
    if (Number.isNaN(n)) return "";
    return n.toFixed(digits);
  }
  /**
   * Triggers the gallery view for images
   * @param {number} number the slide number
   *
   *
   */
  viewImages(number) {
    this.setState({ slide: number }, () => {
      this.setState({ toggler: !this.state.toggler });
    });
  }

  /**
   * Triggers the gallery view for videos
   * @param {number} number the slide number
   *
   *
   */
  viewVideos(number) {
    this.setState(
      {
        slideVideos: number
      },
      () => {
        this.setState({ togglerVideos: !this.state.togglerVideos });
      }
    );
  }

  /**
   * Hides the generate report modal
   *
   *
   *
   */
  hideGenerateReportModal() {
    this.setState({ showGenerateReportModal: false });
  }

  hideGenerateReportWithoutImagesModal() {
    this.setState({ showGenerateReportWithoutImagesModal: false });
  }

  groupAndSortImages(images) {
    function dateStringToTimestamp(dateString) {
      const isItalian = i18next.language === "it";
      if (isItalian) {
        const monthNames = {
          Gennaio: 0,
          Febbraio: 1,
          Marzo: 2,
          Aprile: 3,
          Maggio: 4,
          Giugno: 5,
          Luglio: 6,
          Agosto: 7,
          Settembre: 8,
          Ottobre: 9,
          Novembre: 10,
          Dicembre: 11
        };

        const [day, month, year] = dateString.split(" ");

        const monthIndex = monthNames[month];

        if (monthIndex === undefined) {
          throw new Error("Invalid month name");
        }

        const date = new Date(year, monthIndex, day);
        return date.getTime();
      }
      return new Date(dateString).getTime();
    }
    if (images && images.length > 0) {
      // Helper function to get imageSegment for an image
      // Note: imageSegment only exists for pristine images
      const getImageSegment = image => {
        // If image has imageSegment, use it
        if (image.imageSegment) {
          return image.imageSegment;
        }

        // For edited pristine images, look up the original image's imageSegment
        if (
          image.deviceType === "PRISTINE" &&
          image.originalImageIds &&
          image.originalImageIds.length > 0 &&
          this.state.rawImages?.data
        ) {
          const originalImageId = image.originalImageIds[0];

          // Only search in pristineImages since imageSegment only exists for pristine images
          const pristineStandardImages =
            this.state.rawImages.data.pristineImages?.STANDARD || [];

          const originalImage = pristineStandardImages.find(
            img => img.id === originalImageId
          );
          if (originalImage && originalImage.imageSegment) {
            return originalImage.imageSegment;
          }
        }

        // Default to POSTERIOR if not found
        return "POSTERIOR";
      };

      const groups = images.reduce(
        (acc, image) => {
          const date = convertEpochToDate(image.date); // Convert timestamp to a date string
          if (!acc.map[date]) {
            acc.map[date] = { ANTERIOR: [], POSTERIOR: [] };
            acc.dates.push(dateStringToTimestamp(date)); // Keep track of dates for sorting
          }
          const segment = getImageSegment(image);
          acc.map[date][segment]?.push(image);
          return acc;
        },
        { map: {}, dates: [] }
      );

      // Sort dates in reverse chronological order
      groups.dates.sort((a, b) => b - a);

      // Create a new object with sorted dates
      const sortedGroupedByDate = {};
      groups.dates.forEach(timestamp => {
        const date = convertEpochToDate(timestamp); // Convert back to a date string
        sortedGroupedByDate[date] = groups.map[date];

        // Sort each group by date in reverse chronological order
        sortedGroupedByDate[date]?.ANTERIOR?.sort((a, b) => b.date - a.date);
        sortedGroupedByDate[date]?.POSTERIOR?.sort((a, b) => b.date - a.date);
      });

      return sortedGroupedByDate;
    }
  }

  /**
   * Hides the exam details modal
   *
   *
   *
   */
  hideEditExamDetailsModal() {
    this.setState({ showEditExamDetailsModal: false });
  }

  toggleAddAdminAccountModal() {
    this.setState({
      showAddAccountModal: !this.state.showAddAccountModal
    });
  }

  toggleEditPatientModal() {
    this.setState({ showEditPatientModal: !this.state.showEditPatientModal });
  }

  toggleABHAModal() {
    this.setState({ showABHAModal: !this.state.showABHAModal });
  }

  toggleCustomFieldsDataModal() {
    this.setState({
      showCustomFieldsDataModal: !this.state.showCustomFieldsDataModal
    });
  }

  toggleNeuboPopup(which) {
    this.setState(prev => ({
      neuboPopup: prev.neuboPopup === which ? null : which
    }));
  }

  renderNeuboLabelChips(items) {
    const list = Array.isArray(items) ? items.filter(Boolean) : [];
    if (list.length === 0) {
      return <span className="neubo-popup-empty">-</span>;
    }
    return (
      <div className="neubo-chip-row">
        {list.map((item, idx) => (
          <span className="neubo-chip" key={idx}>
            {item}
          </span>
        ))}
      </div>
    );
  }

  renderNeuboPopup(which, title, content) {
    if (this.state.neuboPopup !== which) return null;
    return (
      <>
        <div
          className="neubo-popup-overlay"
          onClick={() => this.setState({ neuboPopup: null })}
        />
        <div className="neubo-popup" onClick={e => e.stopPropagation()}>
          {title ? <div className="neubo-popup-title">{title}</div> : null}
          {content}
        </div>
      </>
    );
  }

  renderNeuboPatientFields() {
    const patient = this.state.patientDetails || {};
    const np = patient.deviceProfiles?.neubo || {};
    const ne = this.state.examDetails?.deviceProfiles?.neubo || {};
    const examDate =
      this.props?.location?.state?.exam?.examDetails?.examDate ||
      this.state.examDetails?.examDate;
    const { visible, hidden } = splitRiskFactors(np.riskFactors);
    const allRiskFactors = Array.isArray(np.riskFactors)
      ? np.riskFactors.filter(Boolean)
      : [];

    return (
      <>
        <div className="new-exam-details-patient-details">
          <div>
            {this.t(T_ENTITIES.patient.mrn)}:{" "}
            <span className="new-exam-details-value">{patient.mrn || "-"}</span>
          </div>
          <div>
            {this.t(T_ENTITIES.patient.gender)}:{" "}
            <span className="new-exam-details-value">
              {patient.gender === "MALE"
                ? this.t(T_REPORT.male)
                : patient.gender === "FEMALE"
                ? this.t(T_REPORT.female)
                : "-"}
            </span>
          </div>
          <div>
            {this.t(T_NEUBO.dateOfBirth)}:{" "}
            <span className="new-exam-details-value">
              {patient.dateOfBirth
                ? convertEpochToDate(patient.dateOfBirth)
                : "-"}
            </span>
          </div>
          <div>
            {this.t(T_NEUBO.birthTypeOrder)}:{" "}
            <span className="new-exam-details-value">
              {formatBirthTypeOrder(np.birthType, np.birthOrder)}
            </span>
          </div>
          <div>
            {this.t(T_NEUBO.birthWeight)}:{" "}
            <span className="new-exam-details-value">
              {formatBirthWeight(np.birthWeight)}
            </span>
          </div>
          {sessionStorage.getItem("tele") === "true" ? (
            <div>
              {this.t(T_ENTITIES.exam.examState)}:{" "}
              <span className="new-exam-details-value">
                {(() => {
                  switch (this.state.examState) {
                    case "ACTIVE":
                      return this.t(T_ENTITIES.exam.examStateTypes.active);
                    case "ASSIGNED":
                      return this.t(T_ENTITIES.exam.examStateTypes.assigned);
                    case "GRADED":
                      return this.t(T_ENTITIES.exam.examStateTypes.graded);
                    case "ALL":
                      return this.t(T_ENTITIES.exam.examStateTypes.all);
                    default:
                      return "-";
                  }
                })()}
              </span>
            </div>
          ) : null}
          <div>
            {this.t(T_ENTITIES.exam.examDate)}:{" "}
            <span className="new-exam-details-value">
              {examDate ? convertEpochToDate(examDate) : "-"}
            </span>
          </div>
          <div>
            {this.t(T_ENTITIES.exam.deviceType)}:{" "}
            <span className="new-exam-details-value">Neubo</span>
          </div>
        </div>
        <div className="new-exam-details-patient-details neubo-second-col">
          <div>
            {this.t(T_NEUBO.gestationAge)}:{" "}
            <span className="new-exam-details-value">
              {formatWeeksDays(np.gestationalAge)}
            </span>
          </div>
          <div className="neubo-risk-factor-line">
            {this.t(T_NEUBO.riskFactors)}:{" "}
            <span className="new-exam-details-value">
              {visible.length ? visible.join(", ") : "-"}
            </span>
            {hidden.length ? (
              <>
                {", "}
                <span
                  className="neubo-more-link"
                  onClick={() => this.toggleNeuboPopup("risk")}
                >
                  ...{this.t(T_NEUBO.more)}
                  <img
                    className="neubo-expand-arrow"
                    src={require("../../assets/images/down-arrow.svg")}
                  />
                </span>
              </>
            ) : null}
            {this.renderNeuboPopup(
              "risk",
              null,
              this.renderNeuboLabelChips(allRiskFactors)
            )}
          </div>
          <div>
            {this.t(T_NEUBO.postMenstrualAge)}:{" "}
            <span className="new-exam-details-value">
              {postMenstrualAge(
                np.gestationalAge,
                patient.dateOfBirth,
                examDate
              )}
            </span>
          </div>
          <div>
            {this.t(T_NEUBO.currentWeight)}:{" "}
            <span className="new-exam-details-value">
              {formatBirthWeight(ne.currentWeight)}
            </span>
          </div>
          <div className="neubo-expandable-line">
            <span
              className="neubo-more-link"
              onClick={() => this.toggleNeuboPopup("referring")}
            >
              {this.t(T_NEUBO.referringLocationDetails)}
              <img
                className="neubo-expand-arrow"
                src={require("../../assets/images/down-arrow.svg")}
              />
            </span>
            {this.renderNeuboPopup(
              "referring",
              this.t(T_NEUBO.referringLocationDetails),
              <div className="neubo-popup-rows">
                <div>
                  {this.t(T_NEUBO.referringHospital)}:{" "}
                  <span className="new-exam-details-value">
                    {np.referringHospital || "-"}
                  </span>
                </div>
                <div>
                  {this.t(T_NEUBO.referringDoctor)}:{" "}
                  <span className="new-exam-details-value">
                    {np.referringDoctor || "-"}
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="neubo-expandable-line">
            <span
              className="neubo-more-link"
              onClick={() => this.toggleNeuboPopup("examiner")}
            >
              {this.t(T_NEUBO.examinerDetails)}
              <img
                className="neubo-expand-arrow"
                src={require("../../assets/images/down-arrow.svg")}
              />
            </span>
            {this.renderNeuboPopup(
              "examiner",
              this.t(T_NEUBO.examinerDetails),
              <div className="neubo-popup-rows">
                <div>
                  {this.t(T_NEUBO.clinicianName)}:{" "}
                  <span className="new-exam-details-value">
                    {formatPersonName(
                      this.state.orderingProvider?.firstName,
                      this.state.orderingProvider?.lastName
                    )}
                  </span>
                </div>
                <div>
                  {this.t(T_NEUBO.technicianName)}:{" "}
                  <span className="new-exam-details-value">
                    {ne.examTechnician || "-"}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }

  openGenerateReportModal() {
    this.setState({ showGenerateReportModal: true });
  }

  startGradingWithoutImages() {
    putAuthenticatedData(
      sessionStorage.getItem("domain") +
        assignExam +
        "/" +
        this?.props?.location?.state?.exam?.examDetails?.id
    )
      .then(result => {
        if (result.status === 200) {
          this.setState({ showGenerateReportWithoutImagesModal: true });
        }
        return result.json();
      })
      .then(resp => {
        if (
          resp.status.statusCode !== "OK" &&
          resp.status.statusCode !== "FORBIDDEN" &&
          resp.status.statusCode !== "NOT_AUTHORIZED"
        ) {
          toast.error(resp.status.message);
        }
      });
  }
  /**
   * Opens the modal to edit an exam attribute
   * @param {string} attribute the attribute to be edited
   *
   *
   *
   */
  editAttribute(attribute) {
    this.setState({
      selectedAttribute: attribute,
      showEditExamDetailsModal: true
    });
  }
  /**
   * Triggers the API call to view a report
   *
   *
   *
   */
  viewReport() {
    const reportId = this.state.report?.id;
    if (!reportId) {
      toast.error(this.t(T_EXAMS.toast.tryAgainAfterSometime));
      return;
    }
    getAuthenticatedData(
      sessionStorage.getItem("domain") +
        getReportLinkByReportId +
        `/${reportId}`
    ).then(
      result => {
        if (result.status.statusCode === "OK") {
          window.open(result.data, "_blank");
        } else {
          toast.error(this.t(T_EXAMS.toast.tryAgainAfterSometime));
        }
      },
      () => {
        this.setState({
          isLoaded: true
        });
      }
    );
  }

  viewMediosAIReport() {
    getAuthenticatedData(
      sessionStorage.getItem("domain") +
        getAIReportLink +
        `/${this?.props?.location?.state?.exam?.examDetails?.id}`
    ).then(
      result => {
        window.open(result.data, "_blank");
      },
      () => {
        this.setState({
          isLoaded: true
        });
      }
    );
  }

  viewGlaucomaReport() {
    getAuthenticatedData(
      sessionStorage.getItem("domain") +
        getAIReportLink +
        `/${this?.props?.location?.state?.exam?.examDetails?.id}?diseaseName=GMA`
    ).then(
      result => {
        window.open(result.data, "_blank");
      },
      () => {
        this.setState({
          isLoaded: true
        });
      }
    );
  }

  viewEyrisReport() {
    getAuthenticatedData(
      sessionStorage.getItem("domain") +
        getEyrisReportLink +
        `/${this?.props?.location?.state?.exam?.examDetails?.id}`
    ).then(
      result => {
        window.open(result.data, "_blank");
      },
      () => {
        this.setState({
          isLoaded: true
        });
      }
    );
  }

  viewAIReport() {
    getAuthenticatedData(
      sessionStorage.getItem("domain") +
        getAIReportLink +
        `/${this?.props?.location?.state?.exam?.examDetails?.id}?diseaseName=DR`
    ).then(
      result => {
        window.open(result.data, "_blank");
      },
      () => {
        this.setState({
          isLoaded: true
        });
      }
    );
  }

  viewPreviousReport(reportId) {
    if (!reportId) {
      toast.error(this.t(T_EXAMS.toast.tryAgainAfterSometime));
      return;
    }
    getAuthenticatedData(
      sessionStorage.getItem("domain") +
        getReportLinkByReportId +
        `/${reportId}`
    ).then(
      result => {
        if (result.status.statusCode === "OK") {
          window.open(result.data, "_blank");
        } else {
          toast.error(this.t(T_EXAMS.toast.tryAgainAfterSometime));
        }
      },
      () => {
        this.setState({
          isLoaded: true
        });
      }
    );
  }

  resetPatientDetails(patient) {
    this.setState({ patientDetails: patient });
  }

  render() {
    const {
      isLoaded,
      toggler,
      imagesBig,
      images,
      examId,
      slideVideos,
      slide,
      videos,
      videoThumbnails,
      togglerVideos,
      imageCaptions
    } = this.state;
    let primaryExamTemplate,
      visionAssessmentTemplate,
      imagesTemplate,
      reportsTemplate = null;
    if (this.state.selectedTab === 1) {
      primaryExamTemplate = (
        <div className="content-container">
          <div className="medical-history">
            <div className="history-container">
              <h5 className="medical-history-heading">
                {this.t(T_EXAMS.examDetails.primaryExamDetails.ocularHistory)}
              </h5>
              <div
                className="edit-medical-history"
                onClick={() => this.editAttribute("ocularHistory")}
              >
                <img src={require("../../assets/images/edit-icon.svg")} />
              </div>
            </div>
            <div className="medical-history-contents">
              {this.state.ocularHistory && this.state.ocularHistory !== ""
                ? this.state.ocularHistory
                : this.t(T_EXAMS.examDetails.primaryExamDetails.none)}
            </div>
          </div>
        </div>
      );
    }
    if (this.state.selectedTab === 2) {
      visionAssessmentTemplate = (
        <div>
          {(() => {
            if (this.state.visionAssessment) {
              return (
                <div className="content-container">
                  <div className="readings-big-container">
                    <p className="row-title">
                      {this.t(T_EXAMS.examDetails.visionAssessment.rightEye)}
                    </p>
                    <div className="reading-container">
                      <div className="table-heading">
                        {this.t(T_EXAMS.examDetails.visionAssessment.reading1)}
                      </div>
                      <div className="table-readings">
                        <div className="table-row-heading top-left">
                          {this.t(
                            T_EXAMS.examDetails.visionAssessment.spherical
                          )}
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.reReading
                              ?.reading1?.sph
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.reReading
                              ?.reading2?.sph
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.reReading
                              ?.reading3?.sph
                          }
                        </div>
                        <div className="table-aggregate top-right">
                          {
                            this.state.visionAssessment.readingSet1?.reReading
                              ?.average.sph
                          }
                        </div>
                        <div className="table-row-heading">
                          {this.t(
                            T_EXAMS.examDetails.visionAssessment.cylindrical
                          )}
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.reReading
                              ?.reading1?.cyl
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.reReading
                              ?.reading2?.cyl
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.reReading
                              ?.reading3?.cyl
                          }
                        </div>
                        <div className="table-aggregate">
                          {
                            this.state.visionAssessment.readingSet1?.reReading
                              ?.average.cyl
                          }
                        </div>
                        <div className="table-row-heading bottom-left">
                          {this.t(T_EXAMS.examDetails.visionAssessment.axis)}
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.reReading
                              ?.reading1?.axis
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.reReading
                              ?.reading2?.axis
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.reReading
                              ?.reading3?.axis
                          }
                        </div>
                        <div className="table-aggregate bottom-right">
                          {
                            this.state.visionAssessment.readingSet1?.reReading
                              ?.average.axis
                          }
                        </div>
                      </div>
                    </div>
                    <div className="reading-container">
                      <div className="table-heading">
                        {this.t(T_EXAMS.examDetails.visionAssessment.reading2)}
                      </div>
                      <div className="table-readings">
                        <div className="table-row-heading top-left">
                          {this.t(
                            T_EXAMS.examDetails.visionAssessment.spherical
                          )}
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.reReading
                              ?.reading1?.sph
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.reReading
                              ?.reading2?.sph
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.reReading
                              ?.reading3?.sph
                          }
                        </div>
                        <div className="table-aggregate top-right">
                          {
                            this.state.visionAssessment.readingSet2?.reReading
                              ?.average.sph
                          }
                        </div>
                        <div className="table-row-heading">
                          {this.t(
                            T_EXAMS.examDetails.visionAssessment.cylindrical
                          )}
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.reReading
                              ?.reading1?.cyl
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.reReading
                              ?.reading2?.cyl
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.reReading
                              ?.reading3?.cyl
                          }
                        </div>
                        <div className="table-aggregate">
                          {
                            this.state.visionAssessment.readingSet2?.reReading
                              ?.average.cyl
                          }
                        </div>
                        <div className="table-row-heading bottom-left">
                          {this.t(T_EXAMS.examDetails.visionAssessment.axis)}
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.reReading
                              ?.reading1?.axis
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.reReading
                              ?.reading2?.axis
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.reReading
                              ?.reading3?.axis
                          }
                        </div>
                        <div className="table-aggregate bottom-right">
                          {
                            this.state.visionAssessment.readingSet2?.reReading
                              ?.average.axis
                          }
                        </div>
                      </div>
                    </div>
                    <p className="row-title">
                      {this.t(T_EXAMS.examDetails.visionAssessment.leftEye)}
                    </p>
                    <div className="reading-container">
                      <div className="table-readings">
                        <div className="table-row-heading top-left">
                          {this.t(
                            T_EXAMS.examDetails.visionAssessment.spherical
                          )}
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.leReading
                              ?.reading1?.sph
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.leReading
                              ?.reading2?.sph
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.leReading
                              ?.reading3?.sph
                          }
                        </div>
                        <div className="table-aggregate top-right">
                          {
                            this.state.visionAssessment.readingSet1?.leReading
                              ?.average.sph
                          }
                        </div>
                        <div className="table-row-heading">
                          {this.t(
                            T_EXAMS.examDetails.visionAssessment.cylindrical
                          )}
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.leReading
                              ?.reading1?.cyl
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.leReading
                              ?.reading2?.cyl
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.leReading
                              ?.reading3?.cyl
                          }
                        </div>
                        <div className="table-aggregate">
                          {
                            this.state.visionAssessment.readingSet1?.leReading
                              ?.average.cyl
                          }
                        </div>
                        <div className="table-row-heading bottom-left">
                          {this.t(T_EXAMS.examDetails.visionAssessment.axis)}
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.leReading
                              ?.reading1?.axis
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.leReading
                              ?.reading2?.axis
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet1?.leReading
                              ?.reading3?.axis
                          }
                        </div>
                        <div className="table-aggregate bottom-right">
                          {
                            this.state.visionAssessment.readingSet1?.leReading
                              ?.average.axis
                          }
                        </div>
                      </div>
                    </div>
                    <div className="reading-container">
                      <div className="table-readings">
                        <div className="table-row-heading">
                          {this.t(
                            T_EXAMS.examDetails.visionAssessment.spherical
                          )}
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.leReading
                              ?.reading1?.sph
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.leReading
                              ?.reading2?.sph
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.leReading
                              ?.reading3?.sph
                          }
                        </div>
                        <div className="table-aggregate">
                          {
                            this.state.visionAssessment.readingSet2?.leReading
                              ?.average.sph
                          }
                        </div>
                        <div className="table-row-heading">
                          {this.t(
                            T_EXAMS.examDetails.visionAssessment.cylindrical
                          )}
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.leReading
                              ?.reading1?.cyl
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.leReading
                              ?.reading2?.cyl
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.leReading
                              ?.reading3?.cyl
                          }
                        </div>
                        <div className="table-aggregate">
                          {
                            this.state.visionAssessment.readingSet2?.leReading
                              ?.average.cyl
                          }
                        </div>
                        <div className="table-row-heading">
                          {this.t(T_EXAMS.examDetails.visionAssessment.axis)}
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.leReading
                              ?.reading1?.axis
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.leReading
                              ?.reading2?.axis
                          }
                        </div>
                        <div className="table-contents">
                          {
                            this.state.visionAssessment.readingSet2?.leReading
                              ?.reading3?.axis
                          }
                        </div>
                        <div className="table-aggregate">
                          {
                            this.state.visionAssessment.readingSet2?.leReading
                              ?.average.axis
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            } else {
              return (
                <div className="content-container">
                  <div className="no-values-container">
                    <img src={require("../../assets/images/scan.png")} />
                    <p>
                      {this.t(T_EXAMS.examDetails.visionAssessment.noValues)}
                    </p>
                  </div>
                </div>
              );
            }
          })()}
        </div>
      );
    }
    let biometryTemplate = null;
    if (this.state.selectedTab === 5 && this.state.biometryData) {
      const { biometryData } = this.state;
      const rightEye = biometryData.rightEye;
      const leftEye = biometryData.leftEye;

      const isEditingSubjective = this.state.isEditingSubjectiveRefraction;
      const subjectiveDraft = this.state.subjectiveRefractionDraft;
      const renderSubjectiveCell = (eyeKey, eye, field, formatter) => {
        if (isEditingSubjective) {
          // Sphere/Cylinder are in diopters (clinical convention: step 0.25).
          // Axis is in degrees 0-180 (stepping by 5 here per product preference).
          const isAxis = field === "a";
          const step = isAxis ? "5" : "0.25";
          return (
            <input
              type="number"
              step={step}
              min={isAxis ? "0" : undefined}
              max={isAxis ? "180" : undefined}
              className="subjective-refraction-input"
              value={subjectiveDraft[eyeKey][field]}
              onChange={e =>
                this.handleSubjectiveRefractionChange(
                  eyeKey,
                  field,
                  e.target.value
                )
              }
            />
          );
        }
        return formatter(eye?.subjectiveRefractionData?.[field]);
      };

      biometryTemplate = (
        <div className="content-container">
          <div className="biometry-container">
            <div className="biometry-table-container">
              <table className="biometry-table">
                <thead>
                  <tr>
                    <th>EYE</th>
                    <th colSpan="5">Axial</th>
                    <th colSpan="5">Keratometry</th>
                    <th colSpan="3">Objective Refraction</th>
                    <th colSpan="3">Subjective Refraction</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th>CCT</th>
                    <th>ACD</th>
                    <th>LT</th>
                    <th>VT</th>
                    <th>AL</th>
                    <th>K1</th>
                    <th>K2</th>
                    <th>AST</th>
                    <th>AVG K</th>
                    <th>AL/CR</th>
                    <th>S</th>
                    <th>C</th>
                    <th>A</th>
                    <th>S</th>
                    <th>C</th>
                    <th>A</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="eye-label">RE</td>
                    <td>{this.formatCCTBiometry(rightEye?.axialData?.cct)}</td>
                    <td>{this.formatMM(rightEye?.axialData?.ad)}</td>
                    <td>{this.formatMM(rightEye?.axialData?.lt)}</td>
                    <td>{this.formatMM(rightEye?.axialData?.vt)}</td>
                    <td>{this.formatMM(rightEye?.axialData?.al)}</td>
                    <td>
                      {this.formatKeratometryK1(rightEye?.keratometryData?.k1)}
                    </td>
                    <td>
                      {this.formatKeratometryK2(rightEye?.keratometryData?.k2)}
                    </td>
                    <td>
                      {this.formatKeratometryAST(
                        rightEye?.keratometryData?.ast
                      )}
                    </td>
                    <td>{this.formatAvgK(rightEye?.keratometryData?.avgR)}</td>
                    <td>{this.formatALCR(rightEye?.alCr)}</td>
                    <td>
                      {this.formatRefractionS(rightEye?.refractionData?.s)}
                    </td>
                    <td>
                      {this.formatRefractionC(rightEye?.refractionData?.c)}
                    </td>
                    <td>
                      {this.formatRefractionA(rightEye?.refractionData?.a)}
                    </td>
                    <td>
                      {renderSubjectiveCell(
                        "rightEye",
                        rightEye,
                        "s",
                        this.formatRefractionS
                      )}
                    </td>
                    <td>
                      {renderSubjectiveCell(
                        "rightEye",
                        rightEye,
                        "c",
                        this.formatRefractionC
                      )}
                    </td>
                    <td>
                      {renderSubjectiveCell(
                        "rightEye",
                        rightEye,
                        "a",
                        this.formatRefractionA
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="eye-label">LE</td>
                    <td>{this.formatCCTBiometry(leftEye?.axialData?.cct)}</td>
                    <td>{this.formatMM(leftEye?.axialData?.ad)}</td>
                    <td>{this.formatMM(leftEye?.axialData?.lt)}</td>
                    <td>{this.formatMM(leftEye?.axialData?.vt)}</td>
                    <td>{this.formatMM(leftEye?.axialData?.al)}</td>
                    <td>
                      {this.formatKeratometryK1(leftEye?.keratometryData?.k1)}
                    </td>
                    <td>
                      {this.formatKeratometryK2(leftEye?.keratometryData?.k2)}
                    </td>
                    <td>
                      {this.formatKeratometryAST(leftEye?.keratometryData?.ast)}
                    </td>
                    <td>{this.formatAvgK(leftEye?.keratometryData?.avgR)}</td>
                    <td>{this.formatALCR(leftEye?.alCr)}</td>
                    <td>
                      {this.formatRefractionS(leftEye?.refractionData?.s)}
                    </td>
                    <td>
                      {this.formatRefractionC(leftEye?.refractionData?.c)}
                    </td>
                    <td>
                      {this.formatRefractionA(leftEye?.refractionData?.a)}
                    </td>
                    <td>
                      {renderSubjectiveCell(
                        "leftEye",
                        leftEye,
                        "s",
                        this.formatRefractionS
                      )}
                    </td>
                    <td>
                      {renderSubjectiveCell(
                        "leftEye",
                        leftEye,
                        "c",
                        this.formatRefractionC
                      )}
                    </td>
                    <td>
                      {renderSubjectiveCell(
                        "leftEye",
                        leftEye,
                        "a",
                        this.formatRefractionA
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="subjective-refraction-actions">
              {!isEditingSubjective ? (
                <button
                  type="button"
                  className="loginbtn1 edit-subjective-btn"
                  onClick={this.startEditSubjectiveRefraction}
                >
                  {this.hasSubjectiveRefraction()
                    ? "Edit Subjective Refraction"
                    : "Add Subjective Refraction"}
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className="loginbtn1 edit-subjective-btn"
                    onClick={this.saveSubjectiveRefraction}
                    disabled={this.state.isSavingSubjectiveRefraction}
                  >
                    {this.state.isSavingSubjectiveRefraction
                      ? "Saving..."
                      : "Save"}
                  </button>
                  <button
                    type="button"
                    className="cancel-subjective-btn"
                    onClick={this.cancelEditSubjectiveRefraction}
                    disabled={this.state.isSavingSubjectiveRefraction}
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
            <div className="biometry-outcomes">
              <div className="biometry-outcome-item">
                <span
                  className="biometry-link axial-readings-link"
                  onClick={this.toggleAxialReadingsModal}
                >
                  AXIAL READINGS
                </span>
                <span className="biometry-arrow">›</span>
              </div>
              <div className="biometry-outcome-item">
                <span
                  className="biometry-link keratometry-readings-link"
                  onClick={this.toggleKeratometryReadingsModal}
                >
                  KERATOMETRY READINGS
                </span>
                <span className="biometry-arrow">›</span>
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (
      this.state.selectedTab === 3 &&
      !this.state.examDetails?.deviceType?.includes("PRISTINE")
    ) {
      imagesTemplate = (
        <div className="content-container">
          <div className="exam-images">
            <div className="image-heading">
              {this.t(T_EXAMS.examDetails.imagesAndVideos.images)}
            </div>
            <div className="image-grid">
              {(() => {
                if (!this.state?.images || this.state?.images?.length === 0) {
                  return (
                    <p>
                      {this.t(T_EXAMS.examDetails.imagesAndVideos.noImages)}
                    </p>
                  );
                }
                let imageHTML = this.state?.images?.map?.((image, key) => {
                  // Generate a truly unique key that can't be confused with a number
                  const imageStr = String(image || "");
                  const bigImageStr = imagesBig[key]
                    ? String(imagesBig[key])
                    : "";
                  // Use a simple hash of the strings to ensure uniqueness
                  const hash = str => {
                    let h = 0;
                    for (let i = 0; i < str.length; i++) {
                      h = (h << 5) - h + str.charCodeAt(i);
                      h = h & h; // Convert to 32bit integer
                    }
                    return Math.abs(h).toString(36);
                  };
                  const uniqueKey = `img-regular-${key}-${hash(
                    imageStr + bigImageStr
                  )}`;
                  return (
                    <a
                      key={uniqueKey}
                      className="gallery-item"
                      data-sub-html={imageCaptions[key]}
                      href={imagesBig[key]}
                    >
                      <img src={image} alt={`Exam image ${key + 1}`} />
                      {this.renderLateralityBadge(
                        this.state.small?.[key]?.laterality
                      )}
                      {(() => {
                        if (this.state.OneSecondOver) {
                          return (
                            <img
                              className="download-btn"
                              src={require("../../assets/images/download.svg")}
                              onClick={() => {
                                this.download(this.state.imagesBig[key]);
                              }}
                              alt="Download"
                            />
                          );
                        }
                      })()}
                    </a>
                  );
                });
                return (
                  <LightGallery
                    onInit={this.onInit}
                    onSlideItemLoad={this.onSlideItemLoad}
                    onAfterSlide={this.onAfterSlide}
                  >
                    {imageHTML}
                  </LightGallery>
                );
              })()}
            </div>
          </div>
          <div className="exam-images">
            <div className="image-heading">
              {this.t(T_EXAMS.examDetails.imagesAndVideos.editedImages)}
            </div>
            <div className="image-grid">
              {(() => {
                if (
                  !this.state?.editedImages ||
                  this.state?.editedImages?.length === 0
                ) {
                  return (
                    <p>
                      {this.t(T_EXAMS.examDetails.imagesAndVideos.noImages)}
                    </p>
                  );
                }
                let imageEditedHTML = this.state?.editedImages?.map?.(
                  (image, key) => {
                    const baseIndex = this.state?.images?.length || 0;
                    const imageStr = String(image || "");
                    const bigImageStr = imagesBig[key + baseIndex]
                      ? String(imagesBig[key + baseIndex])
                      : "";
                    // Use a simple hash of the strings to ensure uniqueness
                    const hash = str => {
                      let h = 0;
                      for (let i = 0; i < str.length; i++) {
                        h = (h << 5) - h + str.charCodeAt(i);
                        h = h & h; // Convert to 32bit integer
                      }
                      return Math.abs(h).toString(36);
                    };
                    const uniqueKey = `img-edited-${key}-${baseIndex}-${hash(
                      imageStr + bigImageStr
                    )}`;
                    return (
                      <a
                        key={uniqueKey}
                        className="gallery-item"
                        data-sub-html={imageCaptions[key + baseIndex]}
                        href={imagesBig[key + baseIndex]}
                      >
                        <img src={image} alt={`Edited exam image ${key + 1}`} />
                        {this.renderLateralityBadge(
                          this.state.smallEdited?.[key]?.laterality
                        )}
                        {(() => {
                          if (this.state.OneSecondOver) {
                            return (
                              <img
                                className="download-btn"
                                src={require("../../assets/images/download.svg")}
                                onClick={() => {
                                  this.download(
                                    this.state.smallEdited[key].path
                                  );
                                }}
                                alt="Download"
                              />
                            );
                          }
                        })()}
                      </a>
                    );
                  }
                );
                return (
                  <LightGallery
                    onInit={this.onInit}
                    onSlideItemLoad={this.onSlideItemLoad}
                    onAfterSlide={this.onAfterSlide}
                  >
                    {imageEditedHTML}
                  </LightGallery>
                );
              })()}
            </div>
          </div>
          <div className="exam-images">
            <div className="image-heading">
              {this.t(T_EXAMS.examDetails.imagesAndVideos.videos)}
            </div>
            <div className="image-grid image-grid-videos">
              {(() => {
                if (!this.state?.videos || this.state?.videos?.length === 0) {
                  return (
                    <p>
                      {this.t(T_EXAMS.examDetails.imagesAndVideos.noVideos)}
                    </p>
                  );
                }
                return this.state?.videoThumbnails?.map?.((video, key) => (
                  <div key={`video-${key}-${video}`}>
                    <img
                      onClick={() => this.viewVideos(key)}
                      src={video}
                      alt={`Video thumbnail ${key + 1}`}
                    />
                    <img
                      onClick={() => this.viewVideos(key)}
                      className="play-btn"
                      src={require("../../assets/images/play-icon.svg")}
                      alt="Play"
                    />
                    <img
                      className="download-btn"
                      src={require("../../assets/images/download.svg")}
                      onClick={() => {
                        this.download(this.state.videos[key]);
                      }}
                      alt="Download"
                    />
                  </div>
                ));
              })()}
            </div>
          </div>
        </div>
      );
    } else if (
      this.state.selectedTab === 3 &&
      this.state.examDetails?.deviceType?.includes("PRISTINE")
    ) {
      const groupedImages = this.groupAndSortImages(this.state.small);
      const groupedEditedImages = this.groupAndSortImages(
        this.state.smallEdited
      );
      // eslint-disable-next-line no-console
      console.log(groupedImages);
      imagesTemplate = (
        <div className="content-container">
          <div className="exam-images">
            <div className="image-heading">
              {this.t(T_EXAMS.examDetails.imagesAndVideos.images)}
            </div>
            {(() => {
              if (
                !groupedImages ||
                Object.getOwnPropertyNames(groupedImages).length === 0
              ) {
                return (
                  <p>{this.t(T_EXAMS.examDetails.imagesAndVideos.noImages)}</p>
                );
              } else {
                return Object.entries(groupedImages).map(
                  ([date, imagesBySegment]) => {
                    const selectedSegment =
                      this.state.toggledSegments[date] || "POSTERIOR";
                    const imagesToShow = imagesBySegment[selectedSegment];
                    // eslint-disable-next-line no-console
                    console.log(imagesToShow);
                    return (
                      <>
                        <div className="pristine-heading-container">
                          <div className="pristine-date">{date}</div>
                          <div className="toggle-collection">
                            <div
                              className={`left-toggle toggle ${
                                this.state.toggledSegments[date] ===
                                  "POSTERIOR" ||
                                !this.state.toggledSegments[date]
                                  ? "selected"
                                  : ""
                              }`}
                              onClick={() =>
                                this.toggleSegment(date, "POSTERIOR")
                              }
                            >
                              {this.t(
                                T_EXAMS.examDetails.imagesAndVideos.posterior
                              )}
                            </div>
                            <div
                              className={`right-toggle toggle ${
                                this.state.toggledSegments[date] === "ANTERIOR"
                                  ? "selected"
                                  : ""
                              }`}
                              onClick={() =>
                                this.toggleSegment(date, "ANTERIOR")
                              }
                            >
                              {this.t(
                                T_EXAMS.examDetails.imagesAndVideos.anterior
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="image-grid">
                          {(() => {
                            if (!imagesToShow || imagesToShow.length === 0) {
                              return (
                                <p>
                                  {this.t(
                                    T_EXAMS.examDetails.imagesAndVideos.noImages
                                  )}
                                </p>
                              );
                            }
                            let imageHTML = imagesToShow?.map?.(
                              (image, key) => (
                                <a
                                  key={`pristine-image-${date}-${selectedSegment}-${key}-${image.path ||
                                    image.id ||
                                    key}`}
                                  className="gallery-item"
                                  data-sub-html={`<h4 className="img-caption-heading">
                      ${this.props.location.state.exam.patientDetails?.mrn +
                        " - " +
                        this.props.location.state.exam.patientDetails
                          ?.firstName +
                        " " +
                        this.props.location.state.exam.patientDetails
                          ?.lastName +
                        " - " +
                        (image.laterality === "LEFT"
                          ? this.t(T_EXAMS.examDetails.generateReport.leftEye)
                          : this.t(
                              T_EXAMS.examDetails.generateReport.rightEye
                            ))}
                    </h4>`}
                                  href={image.path}
                                >
                                  <img
                                    src={image.thumbnailPath}
                                    alt={`PRISTINE image ${key + 1}`}
                                  />
                                  {this.renderLateralityBadge(image.laterality)}
                                  {(() => {
                                    if (this.state.OneSecondOver) {
                                      return (
                                        <img
                                          className="download-btn"
                                          src={require("../../assets/images/download.svg")}
                                          onClick={() => {
                                            this.download(image.path);
                                          }}
                                          alt="Download"
                                        />
                                      );
                                    }
                                  })()}
                                </a>
                              )
                            );
                            // eslint-disable-next-line no-console
                            console.log(imageHTML);
                            return (
                              <LightGallery
                                key={selectedSegment}
                                onInit={this.onInit}
                                onSlideItemLoad={this.onSlideItemLoad}
                                onAfterSlide={this.onAfterSlide}
                              >
                                {imageHTML}
                              </LightGallery>
                            );
                          })()}
                        </div>
                      </>
                    );
                  }
                );
              }
            })()}
          </div>
          <div className="exam-images">
            <div className="image-heading">
              {this.t(T_EXAMS.examDetails.imagesAndVideos.editedImages)}
            </div>
            {(() => {
              if (
                !groupedEditedImages ||
                Object.getOwnPropertyNames(groupedEditedImages).length === 0
              ) {
                return (
                  <p>{this.t(T_EXAMS.examDetails.imagesAndVideos.noImages)}</p>
                );
              } else {
                return Object.entries(groupedEditedImages).map(
                  ([date, imagesBySegment]) => {
                    const selectedSegmentEdited =
                      this.state.toggledSegmentsEdited[date] || "POSTERIOR";
                    const imagesToShowEdited =
                      imagesBySegment[selectedSegmentEdited];
                    // eslint-disable-next-line no-console
                    console.log(imagesToShowEdited);
                    return (
                      <>
                        <div className="pristine-heading-container">
                          <div className="pristine-date">{date}</div>
                          <div className="toggle-collection">
                            <div
                              className={`left-toggle toggle ${
                                this.state.toggledSegmentsEdited[date] ===
                                  "POSTERIOR" ||
                                !this.state.toggledSegmentsEdited[date]
                                  ? "selected"
                                  : ""
                              }`}
                              onClick={() =>
                                this.toggleSegmentEdited(date, "POSTERIOR")
                              }
                            >
                              {this.t(
                                T_EXAMS.examDetails.imagesAndVideos.posterior
                              )}
                            </div>
                            <div
                              className={`right-toggle toggle ${
                                this.state.toggledSegmentsEdited[date] ===
                                "ANTERIOR"
                                  ? "selected"
                                  : ""
                              }`}
                              onClick={() =>
                                this.toggleSegmentEdited(date, "ANTERIOR")
                              }
                            >
                              {this.t(
                                T_EXAMS.examDetails.imagesAndVideos.anterior
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="image-grid">
                          {(() => {
                            if (
                              !imagesToShowEdited ||
                              imagesToShowEdited.length === 0
                            ) {
                              return (
                                <p>
                                  {this.t(
                                    T_EXAMS.examDetails.imagesAndVideos.noImages
                                  )}
                                </p>
                              );
                            }
                            let imageHTML = imagesToShowEdited?.map?.(
                              (image, key) => (
                                <>
                                  <a
                                    className="gallery-item"
                                    data-sub-html={`<h4 className="img-caption-heading">
                      ${this.props.location.state.exam.patientDetails?.mrn +
                        " - " +
                        this.props.location.state.exam.patientDetails
                          ?.firstName +
                        " " +
                        this.props.location.state.exam.patientDetails
                          ?.lastName +
                        " - " +
                        (image.laterality === "LEFT"
                          ? this.t(T_EXAMS.examDetails.generateReport.leftEye)
                          : this.t(
                              T_EXAMS.examDetails.generateReport.rightEye
                            ))}
                    </h4>`}
                                    href={image.path}
                                    key={key}
                                  >
                                    <img src={image.thumbnailPath} key={key} />
                                    {this.renderLateralityBadge(
                                      image.laterality
                                    )}
                                    {(() => {
                                      if (this.state.OneSecondOver) {
                                        return (
                                          <img
                                            key={key}
                                            className="download-btn"
                                            src={require("../../assets/images/download.svg")}
                                            onClick={() => {
                                              this.download(image.path);
                                            }}
                                          />
                                        );
                                      }
                                    })()}
                                  </a>
                                </>
                              )
                            );
                            // eslint-disable-next-line no-console
                            console.log(imageHTML);
                            return (
                              <LightGallery
                                key={selectedSegmentEdited}
                                onInit={this.onInit}
                                onSlideItemLoad={this.onSlideItemLoad}
                                onAfterSlide={this.onAfterSlide}
                              >
                                {imageHTML}
                              </LightGallery>
                            );
                          })()}
                        </div>
                      </>
                    );
                  }
                );
              }
            })()}
          </div>
        </div>
      );
    }
    if (this.state.selectedTab === 4) {
      // Collect all reports for the Reports section
      const allReports = [];
      if (this.state.report) {
        allReports.push(this.state.report);
      }
      if (this.state.previousReports && this.state.previousReports.length > 0) {
        allReports.push(...this.state.previousReports);
      }

      // Collect all AI reports
      const aiReports = [];
      if (this.props?.location?.state?.exam?.mediosAIReport) {
        aiReports.push({
          type: "mediosAIReport",
          onClick: () => this.viewMediosAIReport(),
          label: this.t(T_EXAMS.examDetails.reports.mediosAiReport),
          image: require("../../assets/images/ai-report.png"),
          hasCareContext: true
        });
      }
      if (
        this.props?.location?.state?.exam?.aiReport &&
        !this.props?.location?.state?.exam?.mediosAIReport
      ) {
        aiReports.push({
          type: "aiReport",
          onClick: () => this.viewAIReport(),
          label: this.t(T_EXAMS.examDetails.reports.drAiReport),
          image: require("../../assets/images/dr-ai-report.svg"),
          hasCareContext: false
        });
      }
      if (
        this.props?.location?.state?.exam?.gmaReport &&
        !this.props?.location?.state?.exam?.mediosAIReport
      ) {
        aiReports.push({
          type: "gmaReport",
          onClick: () => this.viewGlaucomaReport(),
          label: this.t(T_EXAMS.examDetails.reports.glaucomaAiReport),
          image: require("../../assets/images/glaucoma.svg"),
          hasCareContext: false
        });
      }
      if (
        this.props?.location?.state?.exam?.eyrisReport &&
        !this.props?.location?.state?.exam?.mediosAIReport
      ) {
        aiReports.push({
          type: "eyrisReport",
          onClick: () => this.viewEyrisReport(),
          label: this.t(T_EXAMS.examDetails.reports.eyrisReport),
          image: require("../../assets/images/eyris-report.png"),
          hasCareContext: false
        });
      }
      // The myopia report is deliberately NOT added to aiReports: it has its
      // own "Myopia Report" section below and should only appear there.
      const myopiaReportData =
        this.state.myopiaReport ||
        this.props?.location?.state?.exam?.myopiaReport ||
        null;

      reportsTemplate = (
        <div className="content-container">
          <div className="report-buttons-container">
            {/* Reports Section */}
            <div className="report-section">
              <h6 className="report-section-heading">Reports</h6>
              <div
                className="report-megacontainer"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {allReports.length > 0 ? (
                  allReports.map((report, index) => (
                    <div
                      key={report.id || index}
                      onClick={() => {
                        if (report.id) {
                          this.viewPreviousReport(report.id);
                        } else {
                          toast.error(
                            this.t(T_EXAMS.toast.tryAgainAfterSometime)
                          );
                        }
                      }}
                      className="view-report-container"
                    >
                      <img src={require("../../assets/images/report.png")} />
                      <div
                        className="report-label"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px"
                        }}
                      >
                        {convertEpochToDate(report.reportDate)}
                        {report.amendmentReason && (
                          <span
                            data-tip={report.amendmentReason}
                            style={{
                              cursor: "help",
                              marginLeft: "4px",
                              display: "inline-flex",
                              alignItems: "center"
                            }}
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 416.979 416.979"
                              fill="#000000"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85 c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786 c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576 c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765 c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z" />
                            </svg>
                          </span>
                        )}
                      </div>
                      {index === 0 && (
                        <div className="report-label-number">
                          {(() => {
                            if (
                              this.state.careContextData.some(
                                item => item.examFileType === "DOCTOR_REPORT"
                              )
                            ) {
                              const index = this.state.careContextData.findIndex(
                                item => item.examFileType === "DOCTOR_REPORT"
                              );
                              if (
                                this.state.careContextData[index]
                                  .careContextStatus === "UNLINKED"
                              ) {
                                return <>Unlinked</>;
                              } else {
                                return (
                                  <>
                                    Linked with Care Context Number{" "}
                                    {
                                      this.state.careContextData[index]
                                        .careContextReferenceNumber
                                    }
                                  </>
                                );
                              }
                            }
                          })()}
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="view-report-container disabled">
                    <img src={require("../../assets/images/report.png")} />
                    <div className="report-label">Report Not Generated</div>
                  </div>
                )}
              </div>
            </div>

            {/* AI Reports Section */}
            <div className="report-section">
              <h6 className="report-section-heading">AI Reports</h6>
              <div
                className="report-megacontainer"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {aiReports.length > 0 ? (
                  aiReports.map((aiReport, index) => (
                    <div
                      key={aiReport.type}
                      onClick={aiReport.onClick}
                      className="view-report-container"
                    >
                      <img src={aiReport.image} />
                      <div className="report-label">{aiReport.label}</div>
                      {aiReport.hasCareContext && (
                        <div className="report-label-number">
                          {(() => {
                            if (
                              this.state.careContextData.some(
                                item => item.examFileType === "AI_REPORT"
                              )
                            ) {
                              const index = this.state.careContextData.findIndex(
                                item => item.examFileType === "AI_REPORT"
                              );
                              if (
                                this.state.careContextData[index]
                                  .careContextStatus === "UNLINKED"
                              ) {
                                return <>Unlinked</>;
                              } else {
                                return (
                                  <>
                                    Linked with Care Context Number{" "}
                                    {
                                      this.state.careContextData[index]
                                        .careContextReferenceNumber
                                    }
                                  </>
                                );
                              }
                            }
                          })()}
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="view-report-container disabled">
                    <img src={require("../../assets/images/ai-report.png")} />
                    <div className="report-label">AI Report Not Generated</div>
                  </div>
                )}
              </div>
            </div>

            {/* Myopia Report Section */}
            {myopiaReportData && (
              <div className="report-section">
                <h6 className="report-section-heading">Myopia Report</h6>
                <div
                  className="report-megacontainer"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  <div
                    onClick={() => this.viewMyopiaReport()}
                    className="view-report-container"
                  >
                    <img src={require("../../assets/images/ai-report.png")} />
                    <div className="report-label">
                      {this.t(T_EXAMS.examDetails.reports.myopiaReport)}
                    </div>
                    {myopiaReportData.refractionType && (
                      <div className="report-refraction-type">
                        {myopiaReportData.refractionType === "subjective"
                          ? "Subjective refraction"
                          : "Objective refraction"}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }
    if (!isLoaded) {
      return <div className="loading"></div>;
    } else {
      return (
        <div
          className={
            this.state.showPopup || this.state.showModal
              ? "prevent-scrolling"
              : ""
          }
        >
          <AppNavbar />
          <div className="row exam-details-page">
            <div className="col-md-2 sidebar">
              <Sidebar from="3" results={this.state.userResults} />
            </div>
            <div className="col-md-10 sidepadding exam-dark-background">
              <div className="new-exam-details-header">
                <img
                  className="exam-back"
                  onClick={this.props.history.goBack}
                  src={require("../../assets/images/left-arrow-black.svg")}
                />
                <div className="new-exam-details-patient-name">
                  {this.state.patientDetails?.firstName}{" "}
                  {this.state.patientDetails?.lastName
                    ? this.state.patientDetails?.lastName
                    : ""}
                </div>
                <div className="new-exam-details-patient-details-container">
                  {isNeuboDevice(this.state.examDetails?.deviceType) ? (
                    this.renderNeuboPatientFields()
                  ) : (
                    <div className="new-exam-details-patient-details">
                      <div>
                        {this.t(T_ENTITIES.patient.mrn)}:{" "}
                        <span className="new-exam-details-value">
                          {this.state.patientDetails?.mrn}
                        </span>
                      </div>
                      <div>
                        {this.t(T_ENTITIES.patient.gender)}:{" "}
                        <span className="new-exam-details-value">
                          {this.state.patientDetails?.gender === "MALE"
                            ? this.t(T_REPORT.male)
                            : this.t(T_REPORT.female)}
                        </span>
                      </div>
                      <div>
                        {this.t(T_ENTITIES.patient.dateOfBirth)}:{" "}
                        <span className="new-exam-details-value">
                          {convertEpochToDate(
                            this.state.patientDetails?.dateOfBirth
                          )}
                        </span>
                      </div>
                      <div>
                        {this.t(T_ENTITIES.patient.age)}:{" "}
                        <span className="new-exam-details-value">
                          {this.state.patientDetails?.dateOfBirth
                            ? this.calculateAge(
                                this.state.patientDetails.dateOfBirth
                              )
                            : "-"}
                        </span>
                      </div>
                      {(() => {
                        if (sessionStorage.getItem("tele") === "true") {
                          return (
                            <div>
                              {this.t(T_ENTITIES.exam.examState)}:{" "}
                              <span className="new-exam-details-value">
                                {(() => {
                                  switch (this.state.examState) {
                                    case "ACTIVE":
                                      return this.t(
                                        T_ENTITIES.exam.examStateTypes.active
                                      );

                                    case "ASSIGNED":
                                      return this.t(
                                        T_ENTITIES.exam.examStateTypes.assigned
                                      );

                                    case "GRADED":
                                      return this.t(
                                        T_ENTITIES.exam.examStateTypes.graded
                                      );

                                    case "ALL":
                                      return this.t(
                                        T_ENTITIES.exam.examStateTypes.all
                                      );
                                  }
                                })()}
                              </span>
                            </div>
                          );
                        }
                      })()}
                      <div>
                        {this.t(T_ENTITIES.exam.examCode)}:{" "}
                        <span className="new-exam-details-value">
                          {this.state.examDetails?.examCustomId &&
                          this.state.examDetails?.examCustomId !== ""
                            ? this.state.examDetails?.examCustomId
                            : "-"}
                        </span>
                      </div>
                      <div>
                        {this.t(T_ENTITIES.exam.examDate)}:{" "}
                        <span className="new-exam-details-value">
                          {convertEpochToDate(
                            this.props?.location?.state?.exam?.examDetails
                              ?.examDate
                          )}
                        </span>
                      </div>
                      <div>
                        {this.t(T_ENTITIES.exam.deviceType)}:{" "}
                        <span className="new-exam-details-value">
                          {this.state?.examDetails?.deviceType?.reduce(
                            (acc, val) => `${acc} / ${val}`
                          )}
                        </span>
                      </div>
                      {(() => {
                        if (this.state.report?.reportDate) {
                          return (
                            <div>
                              Report Generation Date and Time:{" "}
                              <span className="new-exam-details-value">
                                {convertEpochToDate(
                                  this.state.report?.reportDate
                                )}{" "}
                                at{" "}
                                {convertEpochToTime(
                                  this.state.report?.reportDate
                                )}
                              </span>
                            </div>
                          );
                        }
                      })()}
                      {(() => {
                        if (this.state.patientDetails?.abhaAddress) {
                          return (
                            <div
                              className="editbtn demographic-btn"
                              onClick={() => this.toggleABHAModal()}
                            >
                              View ABHA Demographic Details
                            </div>
                          );
                        }
                      })()}
                      {(() => {
                        if (
                          this.state.patientDetails?.customFieldsData ||
                          this.state.examDetails?.customFieldsData
                        ) {
                          return (
                            <div
                              className="editbtn demographic-btn"
                              onClick={() => this.toggleCustomFieldsDataModal()}
                            >
                              View Custom Fields Data
                            </div>
                          );
                        }
                      })()}
                    </div>
                  )}
                  <div className="right-heading-container">
                    <div
                      className="edit-patient-details"
                      onClick={() => this.toggleEditPatientModal()}
                    >
                      <img src={require("../../assets/images/edit-icon.svg")} />
                    </div>
                    <div className="gen-btn-container">
                      {(() => {
                        if (this.state.images && this.state.editedImages) {
                          return (
                            <Button
                              className="download-exam-btn"
                              onClick={this.zipExam}
                            >
                              {this.t(T_EXAMS.examDetails.downloadExamButton)}
                            </Button>
                          );
                        }
                      })()}
                      {(() => {
                        if (
                          this.state.examDetails?.deviceType?.includes(
                            "INSTAZ"
                          ) ||
                          this.state.examDetails?.deviceType?.includes(
                            "INSTAZM"
                          )
                        ) {
                          return null;
                        }
                        // Check if we have biometry data
                        if (this.state.biometryData) {
                          return (
                            <Button
                              className="generate-report-btn"
                              onClick={this.handleStartGrading}
                              disabled={
                                this.state.isGeneratingBiometryReport ||
                                this.state.isGeneratingMyopiaReport
                              }
                            >
                              {this.state.isGeneratingBiometryReport ||
                              this.state.isGeneratingMyopiaReport ? (
                                <img
                                  src={require("../../assets/images/button-loading.gif")}
                                />
                              ) : (
                                this.t(T_EXAMS.examDetails.generateReportButton)
                              )}
                            </Button>
                          );
                        }

                        // Original logic for other cases.
                        // Build the set of gradeable images across every device
                        // family once, so the button guards below stay readable
                        // and consistent. Pristine contributes only its
                        // POSTERIOR segment; every other device (including
                        // NEUBO) contributes all of its images.
                        const imageData = this.state.rawImages?.data;
                        const collectGradeableImages = type =>
                          typeof imageData === "string"
                            ? []
                            : []
                                .concat(imageData?.fopImages?.[type] || [])
                                .concat(imageData?.aimImages?.[type] || [])
                                .concat(imageData?.pslImages?.[type] || [])
                                .concat(imageData?.otherImages?.[type] || [])
                                .concat(imageData?.obmImages?.[type] || [])
                                .concat(imageData?.instaZImages?.[type] || [])
                                .concat(imageData?.instaZMImages?.[type] || [])
                                .concat(imageData?.instaKCImages?.[type] || [])
                                .concat(imageData?.neuboImages?.[type] || [])
                                .concat(
                                  (
                                    imageData?.pristineImages?.[type] || []
                                  ).filter(
                                    el => el.imageSegment === "POSTERIOR"
                                  )
                                );
                        const hasGradeableImages =
                          collectGradeableImages("STANDARD").length > 0 ||
                          collectGradeableImages("EDITED").length > 0;
                        // The 48-hour grading lockout applies only to pristine
                        // exams (all pristine segments count here, not just
                        // POSTERIOR).
                        const hasPristineImages =
                          typeof imageData === "string"
                            ? false
                            : (
                                imageData?.pristineImages?.["STANDARD"] || []
                              ).concat(
                                imageData?.pristineImages?.["EDITED"] || []
                              ).length > 0;
                        const examOlderThan48Hours =
                          new Date().getTime() -
                            this.state.examDetails.examDate >=
                          48 * 60 * 60 * 1000;
                        if (
                          typeof imageData === "string" ||
                          // 48-hour grading lockout — pristine exams only.
                          (hasPristineImages &&
                            examOlderThan48Hours &&
                            !this.state.visionAssessment) ||
                          (!hasGradeableImages &&
                            !this.state.visionAssessment) ||
                          !this.state.isDoctor
                        ) {
                          return null;
                        } else if (sessionStorage.getItem("tele") === "true") {
                          if (
                            typeof imageData === "string" ||
                            !hasGradeableImages ||
                            // 48-hour lockout — pristine exams only.
                            (hasPristineImages && examOlderThan48Hours)
                          ) {
                            return (
                              <Button
                                className="generate-report-btn"
                                onClick={this.startGradingWithoutImages}
                              >
                                {this.t(T_EXAMS.examDetails.startGradingButton)}
                              </Button>
                            );
                          }
                          return (
                            <Button
                              className="generate-report-btn"
                              onClick={this.startGrading}
                            >
                              {this.t(T_EXAMS.examDetails.startGradingButton)}
                            </Button>
                          );
                        } else {
                          return (
                            <Button
                              className="generate-report-btn"
                              onClick={this.openGenerateReportModal}
                            >
                              {this.t(T_EXAMS.examDetails.generateReportButton)}
                            </Button>
                          );
                        }
                      })()}
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-content-container">
                <div className="tabs-container">
                  <div
                    onClick={() => {
                      this.setTab(1);
                    }}
                    className={`tab ${
                      this.state.selectedTab === 1 ? "selected" : ""
                    }`}
                  >
                    <div className="tab-container">
                      <div className="tab-contents-container">
                        <div className="tab-heading">
                          {this.t(T_EXAMS.examDetails.primaryExamDetailsTab)}
                        </div>
                      </div>
                    </div>
                  </div>
                  {(() => {
                    if (
                      this.state.examDetails?.deviceType?.includes(
                        "INSTAREF"
                      ) ||
                      this.state.examDetails?.deviceType?.includes("INSTAZ") ||
                      this.state.examDetails?.deviceType?.includes("INSTAZM")
                    ) {
                      return (
                        <div
                          onClick={() => {
                            this.setTab(2);
                          }}
                          className={`tab ${
                            this.state.selectedTab === 2 ? "selected" : ""
                          }`}
                        >
                          <div className="tab-container">
                            <div className="tab-contents-container">
                              <div className="tab-heading">
                                {this.t(
                                  T_EXAMS.examDetails.visionAssessmentTab
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })()}
                  {(() => {
                    if (this.state.biometryData) {
                      return (
                        <div
                          onClick={() => {
                            this.setTab(5);
                          }}
                          className={`tab ${
                            this.state.selectedTab === 5 ? "selected" : ""
                          }`}
                        >
                          <div className="tab-container">
                            <div className="tab-contents-container">
                              <div className="tab-heading">Biometry Data</div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })()}

                  <div
                    onClick={() => {
                      this.setTab(3);
                    }}
                    className={`tab ${
                      this.state.selectedTab === 3 ? "selected" : ""
                    }`}
                  >
                    <div className="tab-container">
                      <div className="tab-contents-container">
                        <div className="tab-heading">
                          {this.t(T_EXAMS.examDetails.imagesAndVideosTab)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      this.setTab(4);
                    }}
                    className={`tab ${
                      this.state.selectedTab === 4 ? "selected" : ""
                    }`}
                  >
                    <div className="tab-container">
                      <div className="tab-contents-container">
                        <div className="tab-heading">
                          {this.t(T_EXAMS.examDetails.reportsTab)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {primaryExamTemplate}
                {visionAssessmentTemplate}
                {biometryTemplate}
                {imagesTemplate}
                {reportsTemplate}
              </div>
            </div>
          </div>
          {this.state.showGenerateReportModal ? (
            <CustomGenerateReportModal
              text='Click "Close Button" to hide popup'
              closePopup={this.hideGenerateReportModal}
              resetList={this.resetList}
              makeAdmin={true}
              hasImages={
                !(
                  !this.state?.images ||
                  (this.state.rawImages?.data?.fopImages?.["STANDARD"]
                    .concat(this.state.rawImages?.data?.aimImages?.["STANDARD"])
                    .concat(this.state.rawImages?.data?.pslImages?.["STANDARD"])
                    .concat(
                      this.state.rawImages?.data?.otherImages?.["STANDARD"]
                    )
                    .concat(this.state.rawImages?.data?.obmImages?.["STANDARD"])
                    .concat(
                      this.state.rawImages?.data?.instaZImages?.["STANDARD"]
                    )
                    .concat(
                      this.state.rawImages?.data?.instaZMImages?.["STANDARD"] ||
                        []
                    )
                    .concat(
                      this.state.rawImages?.data?.instaKCImages?.["STANDARD"]
                    )
                    .concat(
                      this.state.rawImages?.data?.pristineImages?.[
                        "STANDARD"
                      ].filter(el => el.imageSegment === "POSTERIOR")
                    )
                    .concat(
                      this.state.rawImages?.data?.neuboImages?.["STANDARD"] ||
                        []
                    ).length === 0 &&
                    this.state.rawImages?.data?.fopImages?.["EDITED"]
                      .concat(this.state.rawImages?.data?.aimImages?.["EDITED"])
                      .concat(this.state.rawImages?.data?.pslImages?.["EDITED"])
                      .concat(
                        this.state.rawImages?.data?.otherImages?.["EDITED"]
                      )
                      .concat(this.state.rawImages?.data?.obmImages?.["EDITED"])
                      .concat(
                        this.state.rawImages?.data?.instaZImages?.["EDITED"]
                      )
                      .concat(
                        this.state.rawImages?.data?.instaZMImages?.["EDITED"] ||
                          []
                      )
                      .concat(
                        this.state.rawImages?.data?.instaKCImages?.["EDITED"]
                      )
                      .concat(
                        this.state.rawImages?.data?.instaKCImages?.["EDITED"]
                      )
                      .concat(
                        this.state.rawImages?.data?.pristineImages?.[
                          "EDITED"
                        ].filter(el => el.imageSegment === "POSTERIOR")
                      )
                      .concat(
                        this.state.rawImages?.data?.neuboImages?.["EDITED"] ||
                          []
                      ).length === 0)
                )
              }
              hasAssessment={!!this.state.visionAssessment}
              visionAssessment={this.state.visionAssessment}
              exam={this.props.location.state.exam}
              deviceType={this.props.location.state.deviceType}
              small={this.state.small}
              smallEdited={this.state.smallEdited}
              history={this.props.history}
              hasReport={!!this.state.report}
            />
          ) : null}
          {this.state.showGenerateReportWithoutImagesModal ? (
            <CustomGenerateReportWithoutImagesModal
              text='Click "Close Button" to hide popup'
              closePopup={this.hideGenerateReportWithoutImagesModal}
              resetList={this.resetList}
              makeAdmin={true}
              hasImages={
                !(!this.state?.images || this.state?.images?.length === 0)
              }
              history={this.props.history}
              hasAssessment={!!this.state.visionAssessment}
              visionAssessment={this.state.visionAssessment}
              exam={this.props.location.state.exam}
              deviceType={this.props.location.state.deviceType}
              small={this.state.small}
              smallEdited={this.state.smallEdited}
            />
          ) : null}
          {this.state.showEditExamDetailsModal ? (
            <CustomEditExamDetailsModal
              closePopup={this.hideEditExamDetailsModal}
              resetList={this.resetList}
              selectedAttribute={
                this.state.editableAttributes[this.state.selectedAttribute]
              }
              attr={this.state.selectedAttribute}
              examId={this.state.examId}
              updateValue={this.updateValue}
            />
          ) : null}
          {this.state.showEditPatientModal ? (
            <CustomEditPatientExamModal
              text='Click "Close Button" to hide popup'
              closePopup={this.toggleEditPatientModal}
              resetList={this.resetList}
              patient={
                this.state.patientDetails
                  ? this.state.patientDetails
                  : this.props?.location?.state?.exam?.patientDetails
              }
              examCode={this.state.examDetails?.examCustomId}
              deviceType={this.state?.examDetails?.deviceType}
              examId={this.state.examDetails?.id}
              sites={this.state.sites}
            />
          ) : null}
          {this.state.showABHAModal ? (
            <CustomABHAModal
              text='Click "Close Button" to hide popup'
              closePopup={this.toggleABHAModal}
              resetList={this.resetList}
              patient={
                this.state.patientDetails
                  ? this.state.patientDetails
                  : this.props?.location?.state?.exam?.patientDetails
              }
            />
          ) : null}
          {this.state.showCustomFieldsDataModal ? (
            <CustomFieldsDataModal
              text='Click "Close Button" to hide popup'
              closePopup={this.toggleCustomFieldsDataModal}
              resetList={this.resetList}
              patient={
                this.state.patientDetails
                  ? this.state.patientDetails
                  : this.props?.location?.state?.exam?.patientDetails
              }
              exam={
                this.state.examDetails
                  ? this.state.examDetails
                  : this.props?.location?.state?.exam?.examDetails
              }
              siteData={this.state.sites?.find(
                site => site.siteId === this.state.patientDetails?.siteId
              )}
            />
          ) : null}
          {(() => {
            if (!images || !imagesBig) {
              return null;
            } else {
              return (
                <FsLightbox
                  toggler={toggler}
                  sources={imagesBig}
                  sourceIndex={slide}
                  thumbs={images}
                  captions={imageCaptions}
                  initialAnimation="scale-in-long"
                  type="image"
                  key={"image" + this.state.slide}
                  showThumbsOnMount={false}
                />
              );
            }
          })()}
          {(() => {
            if (!videos || !videoThumbnails) {
              return null;
            } else {
              return (
                <FsLightbox
                  toggler={togglerVideos}
                  sources={videos}
                  sourceIndex={slideVideos}
                  thumbs={videoThumbnails}
                  type="video"
                  key={"video" + slideVideos}
                  showThumbsOnMount={true}
                />
              );
            }
          })()}
          {this.state.showAxialReadingsModal && this.state.biometryData ? (
            <div className="custommodal">
              <div className="custommodalinner axial-readings-modal">
                <div className="firstpage">
                  <div className="hrpadding">
                    <h4 className="modal-heading">Axial Readings</h4>
                    <button
                      className="cancle"
                      onClick={this.toggleAxialReadingsModal}
                    >
                      <span className="cross">✕</span>
                    </button>
                  </div>
                  <div className="axial-readings-content">
                    <div className="axial-eye-section">
                      <h5 className="axial-eye-title">OD/R</h5>
                      <table className="axial-readings-table">
                        <thead>
                          <tr>
                            <th>Readings</th>
                            <th>CCT</th>
                            <th>ACD</th>
                            <th>LT</th>
                            <th>VT</th>
                            <th>AL</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>R1</td>
                            <td>
                              {this.formatCCT(
                                this.state.biometryData.rightEye?.axialData
                                  ?.cctArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.adArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.ltArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.vtArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.alArray?.[0]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R2</td>
                            <td>
                              {this.formatCCT(
                                this.state.biometryData.rightEye?.axialData
                                  ?.cctArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.adArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.ltArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.vtArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.alArray?.[1]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R3</td>
                            <td>
                              {this.formatCCT(
                                this.state.biometryData.rightEye?.axialData
                                  ?.cctArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.adArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.ltArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.vtArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.alArray?.[2]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R4</td>
                            <td>
                              {this.formatCCT(
                                this.state.biometryData.rightEye?.axialData
                                  ?.cctArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.adArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.ltArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.vtArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.alArray?.[3]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R5</td>
                            <td>
                              {this.formatCCT(
                                this.state.biometryData.rightEye?.axialData
                                  ?.cctArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.adArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.ltArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.vtArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData
                                  ?.alArray?.[4]
                              )}
                            </td>
                          </tr>
                          <tr className="axial-average-row">
                            <td>AVG</td>
                            <td>
                              {this.formatCCT(
                                this.state.biometryData.rightEye?.axialData?.cct
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData?.ad
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData?.lt
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData?.vt
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.rightEye?.axialData?.al
                              )}
                            </td>
                          </tr>
                          <tr className="axial-sd-row">
                            <td>SD</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="axial-eye-section">
                      <h5 className="axial-eye-title">OS/L</h5>
                      <table className="axial-readings-table">
                        <thead>
                          <tr>
                            <th>Readings</th>
                            <th>CCT</th>
                            <th>ACD</th>
                            <th>LT</th>
                            <th>VT</th>
                            <th>AL</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>R1</td>
                            <td>
                              {this.formatCCT(
                                this.state.biometryData.leftEye?.axialData
                                  ?.cctArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.adArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.ltArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.vtArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.alArray?.[0]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R2</td>
                            <td>
                              {this.formatCCT(
                                this.state.biometryData.leftEye?.axialData
                                  ?.cctArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.adArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.ltArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.vtArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.alArray?.[1]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R3</td>
                            <td>
                              {this.formatCCT(
                                this.state.biometryData.leftEye?.axialData
                                  ?.cctArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.adArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.ltArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.vtArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.alArray?.[2]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R4</td>
                            <td>
                              {this.formatCCT(
                                this.state.biometryData.leftEye?.axialData
                                  ?.cctArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.adArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.ltArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.vtArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.alArray?.[3]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R5</td>
                            <td>
                              {this.formatCCT(
                                this.state.biometryData.leftEye?.axialData
                                  ?.cctArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.adArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.ltArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.vtArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData
                                  ?.alArray?.[4]
                              )}
                            </td>
                          </tr>
                          <tr className="axial-average-row">
                            <td>AVG</td>
                            <td>
                              {this.formatCCT(
                                this.state.biometryData.leftEye?.axialData?.cct
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData?.ad
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData?.lt
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData?.vt
                              )}
                            </td>
                            <td>
                              {this.formatMM(
                                this.state.biometryData.leftEye?.axialData?.al
                              )}
                            </td>
                          </tr>
                          <tr className="axial-sd-row">
                            <td>SD</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {this.state.showKeratometryReadingsModal &&
          this.state.biometryData ? (
            <CustomKeratometryModal
              closePopup={this.toggleKeratometryReadingsModal}
              biometryData={this.state.biometryData}
            />
          ) : null}
          {this.state.showReportFormatModal ? (
            <CustomReportFormatModal
              closePopup={this.toggleReportFormatModal}
              onSimpleReportSelect={this.handleSimpleReportSelect}
              onMyopiaReportSelect={this.openRefractionChoiceModal}
            />
          ) : null}
          {this.state.showRefractionChoiceModal ? (
            <MyopiaRefractionChoiceModal
              closePopup={this.closeRefractionChoiceModal}
              onSelect={this.handleRefractionTypeSelect}
              subjectiveAvailable={this.hasSubjectiveRefraction()}
            />
          ) : null}
          {this.state.showMyopiaPredictiveGraphModal ? (
            <MyopiaPredictiveGraphModal
              closePopup={this.closeMyopiaPredictiveGraphModal}
              onGenerateReport={this.generateMyopiaReportWithSelection}
              predictiveData={this.state.myopiaPredictiveData}
              currentRef={this.state.myopiaCurrentRef}
            />
          ) : null}
          {this.state.showAmendmentReasonModal ? (
            <div className="custommodal">
              <div className="custommodalinner">
                <form className="loginpad" onSubmit={e => e.preventDefault()}>
                  <h6 className="modal-heading">Amendment Reason</h6>
                  <Button
                    className="cancle"
                    onClick={() => this.toggleAmendmentReasonModal()}
                  >
                    {" "}
                    x{" "}
                  </Button>
                  <hr className="hrpadding" />
                  <div className="firstpage">
                    <p style={{ marginBottom: "20px" }}>
                      A report has already been generated for this exam. Please
                      provide a reason for the amendment.
                    </p>
                    <FormGroup controlId="amendmentReason">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          Amendment Reason <span className="required">*</span>
                        </div>
                        <div className="col-md-9">
                          <textarea
                            id="amendmentReason"
                            name="amendmentReason"
                            className="form-control"
                            rows="4"
                            placeholder="Enter the reason for amending this report..."
                            value={this.state.amendmentReason}
                            onChange={e =>
                              this.setState({ amendmentReason: e.target.value })
                            }
                            required
                            style={{ width: "100%", padding: "8px" }}
                          />
                        </div>
                      </div>
                    </FormGroup>
                    <FormGroup controlId="submitButton">
                      <div className="row">
                        <Button
                          className="loginbtn1"
                          onClick={() => this.handleAmendmentReasonSubmit()}
                          disabled={!this.state.amendmentReason.trim()}
                          style={{ width: "100%" }}
                        >
                          Proceed
                        </Button>
                      </div>
                    </FormGroup>
                  </div>
                </form>
              </div>
            </div>
          ) : null}
          <ReactTooltip />
          {this.state.showAxialReadingsModal && this.state.biometryData ? (
            <div className="custommodal">
              <div className="custommodalinner axial-readings-modal">
                <div className="firstpage">
                  <div className="hrpadding">
                    <h4 className="modal-heading">Axial Readings</h4>
                    <button
                      className="cancle"
                      onClick={this.toggleAxialReadingsModal}
                    >
                      <span className="cross">✕</span>
                    </button>
                  </div>
                  <div className="axial-readings-content">
                    <div className="axial-eye-section">
                      <h5 className="axial-eye-title">OD/R</h5>
                      <table className="axial-readings-table">
                        <thead>
                          <tr>
                            <th>Readings</th>
                            <th>CCT</th>
                            <th>ACD</th>
                            <th>LT</th>
                            <th>VT</th>
                            <th>AL</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>R1</td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.cctArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.adArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.ltArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.vtArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.alArray?.[0]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R2</td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.cctArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.adArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.ltArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.vtArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.alArray?.[1]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R3</td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.cctArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.adArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.ltArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.vtArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.alArray?.[2]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R4</td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.cctArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.adArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.ltArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.vtArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.alArray?.[3]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R5</td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.cctArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.adArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.ltArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.vtArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData
                                  ?.alArray?.[4]
                              )}
                            </td>
                          </tr>
                          <tr className="axial-average-row">
                            <td>AVG</td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData?.cct
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData?.ad
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData?.lt
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData?.vt
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.rightEye?.axialData?.al
                              )}
                            </td>
                          </tr>
                          <tr className="axial-sd-row">
                            <td>SD</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="axial-eye-section">
                      <h5 className="axial-eye-title">OS/L</h5>
                      <table className="axial-readings-table">
                        <thead>
                          <tr>
                            <th>Readings</th>
                            <th>CCT</th>
                            <th>ACD</th>
                            <th>LT</th>
                            <th>VT</th>
                            <th>AL</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>R1</td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.cctArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.adArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.ltArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.vtArray?.[0]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.alArray?.[0]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R2</td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.cctArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.adArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.ltArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.vtArray?.[1]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.alArray?.[1]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R3</td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.cctArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.adArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.ltArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.vtArray?.[2]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.alArray?.[2]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R4</td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.cctArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.adArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.ltArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.vtArray?.[3]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.alArray?.[3]
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>R5</td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.cctArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.adArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.ltArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.vtArray?.[4]
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData
                                  ?.alArray?.[4]
                              )}
                            </td>
                          </tr>
                          <tr className="axial-average-row">
                            <td>AVG</td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData?.cct
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData?.ad
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData?.lt
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData?.vt
                              )}
                            </td>
                            <td>
                              {this.formatBiometryValue(
                                this.state.biometryData.leftEye?.axialData?.al
                              )}
                            </td>
                          </tr>
                          <tr className="axial-sd-row">
                            <td>SD</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {this.state.showKeratometryReadingsModal &&
          this.state.biometryData ? (
            <CustomKeratometryModal
              closePopup={this.toggleKeratometryReadingsModal}
              biometryData={this.state.biometryData}
            />
          ) : null}
        </div>
      );
      // return (
      //   <div
      //     className={
      //       this.state.showPopup || this.state.showModal
      //         ? "prevent-scrolling"
      //         : ""
      //     }
      //   >
      //     <AppNavbar />
      //     <div className="row">
      //       <div className="col-md-2 sidebar">
      //         <Sidebar from="3" results={this.state.userResults} />
      //       </div>
      //       <div className="col-md-10 sidepadding">
      //         <div className="row rowmargin abovetable custom-flex-wrapper">
      //           <a className="back-link" onClick={this.props.history.goBack}>
      //             &lt; Back
      //           </a>
      //           <div className="report-buttons">
      //             {(() => {
      //               if (
      //                 (!this.state.images && !this.state.editedImages) ||
      //                 !this.state.isDoctor
      //               ) {
      //                 return null;
      //               } else if (sessionStorage.getItem("tele") === "true") {
      //                 return (
      //                   <Button
      //                     className="addaccount"
      //                     onClick={this.startGrading}
      //                   >
      //                     Start Grading
      //                   </Button>
      //                 );
      //               } else {
      //                 return (
      //                   <Button
      //                     className="addaccount"
      //                     onClick={this.openGenerateReportModal}
      //                   >
      //                     Generate Report
      //                   </Button>
      //                 );
      //               }
      //             })()}
      //           </div>
      //         </div>
      //         <h4 className="patient-name">
      //           {this.state.patientDetails?.firstName}{" "}
      //           {this.state.patientDetails?.lastName}
      //         </h4>
      //         <div className="patient-details-big-container">
      //           <div className="patient-details-heading-container">
      //             <div className="patient-details-heading">Patient Details</div>
      //             <div
      //               className="edit-patient-details"
      //               onClick={() => this.toggleEditPatientModal()}
      //             >
      //               <img src={require("../../assets/images/edit-icon.svg")} />
      //             </div>
      //           </div>
      //           <div className="patient-details-container">
      //             <div>
      //               <span className="patient-details-heading">Gender: </span>
      //               <div className="patient-gender">
      //                 {this.state.patientDetails?.gender}
      //               </div>
      //             </div>
      //             <div>
      //               <span className="patient-details-heading">MRN: </span>
      //               {this.state.patientDetails?.mrn}
      //             </div>
      //           </div>
      //           <div className="patient-details-container">
      //             <div>
      //               <span className="patient-details-heading">DOB: </span>
      //               {convertEpochToDate(this.state.patientDetails?.dateOfBirth)}
      //             </div>
      //           </div>
      //         </div>
      //         <div className="exam-details">
      //           <h5 className="exam-details-heading">Exam Details</h5>
      //           <div className="patient-details-container">
      //             <div>
      //               <span className="patient-details-heading">Exam Date: </span>
      //               {convertEpochToDate(
      //                 this.props?.location?.state?.exam?.examDetails?.examDate
      //               )}
      //             </div>
      //             <div>
      //               <span className="patient-details-heading">
      //                 Device Type:{" "}
      //               </span>
      //               {this.props?.location?.state?.exam?.examDetails?.deviceType.reduce(
      //                 (acc, val) => `${acc} / ${val}`
      //               )}
      //             </div>
      //           </div>
      //           <div className="patient-details-container">
      //             <div>
      //               <span className="patient-details-heading">Exam Code: </span>
      //               {this.props?.location?.state?.exam?.examDetails
      //                 ?.examCustomId &&
      //               this.props?.location?.state?.exam?.examDetails
      //                 ?.examCustomId !== ""
      //                 ? this.props?.location?.state?.exam?.examDetails
      //                     ?.examCustomId
      //                 : "-"}
      //             </div>
      //             {(() => {
      //               if (sessionStorage.getItem("tele") === "true") {
      //                 return (
      //                   <div>
      //                     <span className="patient-details-heading">
      //                       Exam State:{" "}
      //                     </span>
      //                     {this.state.examState}
      //                   </div>
      //                 );
      //               }
      //             })()}
      //           </div>
      //         </div>

      //       </div>
      //     </div>

      //   </div>
      // );
    }
  }
}

export default withTranslation()(ExamDetails);
